import React, { useState, useEffect, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import jaLocale from "@fullcalendar/core/locales/ja";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import axios from "axios";
import _ from "lodash";

// mui追加
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Backdrop from '@mui/material/Backdrop';
//import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
//import Snackbar from '@mui/material/Snackbar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListSubheader from '@mui/material/ListSubheader';
import Avatar from '@mui/material/Avatar';
import Skeleton from '@mui/material/Skeleton';
import InputAdornment from '@mui/material/InputAdornment';
import Popover from '@mui/material/Popover';
import ButtonGroup from '@mui/material/ButtonGroup';
import Chip from '@mui/material/Chip';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Drawer from '@mui/material/Drawer';


import toast, { Toaster } from 'react-hot-toast';

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EditNoteIcon from "@mui/icons-material/EditNote";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClearIcon from "@mui/icons-material/Clear";
import ColorLensIcon from '@mui/icons-material/ColorLens';
import LinkIcon from '@mui/icons-material/Link';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import SearchIcon from '@mui/icons-material/Search';
import SubjectIcon from '@mui/icons-material/Subject';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CircleIcon from '@mui/icons-material/Circle';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';

// import OutboxIcon from '@mui/icons-material/Outbox';
// import AccessAlarmOutlinedIcon from "@mui/icons-material/AccessAlarmOutlined";

import useMediaQuery from '@mui/material/useMediaQuery';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker";
import { MultiSectionDigitalClock } from '@mui/x-date-pickers/MultiSectionDigitalClock';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';

import { ThemeProvider, createTheme, useTheme, alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";

import dayjs from "dayjs";
import ja from "dayjs/locale/ja";
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

import styled from "@emotion/styled";
import { useLocation } from "react-router-dom";
import { useSwipeable } from "react-swipeable"; // スワイプイベント検知

// styled

// withStyles



// dayjs extended
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.locale('ja'); // 日本語ロケールを設定

//const styles = {
//    dialogPaper: {
//        minHeight: '70vh',
//        maxHeight: '70vh',
//    }
//}


//const cors =require('cors')

// 変更前のstateを持っておくカスタムHook 
function usePrevious(value) {
    const ref = useRef(null);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

// 認証情報は sessionRef（ページに閉じた ref）だけで持つ。
// 以前は apikey を localStorage に置いてショートカット起動時の /check を省いていたが、
// カレンダーは Chatis の iframe からしか開かれなくなり（起動のたびに一時トークンが発行される）、
// その仕組みごと廃止した。ここでは過去の版が残した鍵を掃除するだけ。
const OBSOLETE_CACHE_KEYS = ["honbuid", "roomid", "apikey"];

const clearObsoleteCache = () => {
    try {
        OBSOLETE_CACHE_KEYS.forEach((key) => localStorage.removeItem(key));
    } catch (e) {
        // localStorage が触れない環境（プライベートモード等）では掃除を諦めるだけ
    }
};

// =================================================================
// ★ テスト用設定: 認証を行うかどうか (true: 認証あり, false: 認証スキップ)
//
// false にすると /check を呼ばずに起動する。Chatis の iframe の外（VS Code の
// F5 など）では一時トークンが発行されず /check が必ず 401 になるため、
// ローカル開発中だけ false にする。**false のままコミットしないこと。**
//
// honbuid / roomid は URL パラメータが優先され、無ければ下の開発用既定値
// （ClientApp/.env.development の REACT_APP_DEV_HONBUID / REACT_APP_DEV_ROOMID）を使う。
// サーバ側（GET /events の apikey 照合）も Development では既定でスキップする。
// =================================================================
const ENABLE_AUTH = true;

// 認証スキップ時に使う開発用の既定値。
// roomid=0（マイカレンダー）は /check がマイルームの実 roomid を返して初めて成立するため、
// 認証スキップ時は 0 ではなく実在する部屋の roomid を指定すること。
const DEV_HONBUID = process.env.REACT_APP_DEV_HONBUID || "1";
const DEV_ROOMID = process.env.REACT_APP_DEV_ROOMID || "1";

function App() {
    const search = useLocation().search;
    const query = new URLSearchParams(search);
    const paramhonbuid = query.get('honbuid') ?? (ENABLE_AUTH ? null : DEV_HONBUID);
    const paramroomid = query.get('roomid') ?? (ENABLE_AUTH ? null : DEV_ROOMID);
    const modeParam = query.get('mode');
    const isDarkMode = modeParam === 'dark';

    // このページ（＝1回の起動）が操作する部屋と、その認証情報。
    // 以前は localStorage に置いていたが、localStorage はオリジン単位で
    // 全カレンダー（別の部屋・別タブ・前回の起動）と共有されるため、
    // 直前に開いた部屋の roomid が残って別部屋の予定が表示されたり、
    // /check が終わる前に走った fetch が古い roomid を使ったりしていた。
    // roomid の入力は URL の roomid だけとし、ページに閉じた ref で保持する。
    // roomid=0（マイカレンダー）の時だけ、/check が返すマイルームの roomid に差し替わる。
    const sessionRef = useRef({
        honbuid: paramhonbuid,
        roomid: paramroomid,
        apikey: "",
    });

    const theme = React.useMemo(() => createTheme({
        palette: {
            mode: isDarkMode ? 'dark' : 'light',

            // 背景色グレー（ダークモード時はグレーの色味を反転させて視認性を上げる）
            BGwhitegrey: { main: isDarkMode ? grey[800] : grey[50] },
            BGgrey200: { main: isDarkMode ? grey[700] : grey[200] },
            BGgrey: { main: isDarkMode ? grey[600] : grey[300] },
            BGgrey400: { main: isDarkMode ? grey[500] : grey[400] },
            BGgrey500: { main: isDarkMode ? grey[400] : grey[500] },

            // 以下、予定のカラーリング g〇〇gleカレンダーの色を拝借
        // デフォルト（ピーコック）
            GCdefault: { main: "#039BE5" },
        // トマト
            GCtomato: { main: "#D50000" },
        // フラミンゴ
            GCflamingo: { main: "#E67C73" },
        // ミカン
            GCorange: { main: "#F4511E" },
        // バナナ
            GCbanana: { main: "#F6BF26" },
        // セージ
            GCsage: { main: "#33B679" },
        // バジル
            GCbasil: { main: "#0B8043" },
        // ブルーベリー
            GCblueberry: { main: "#3F51B5" },
        // ラベンダー
            GClavender: { main: "#7986CB" },
        // ブドウ
            GCgrape: { main: "#8E24AA" },
        // グラファイト
            GCgraphite: { main: "#616161" },
        },
        components: {
            MuiMenu: {
                styleOverrides: {
                    list: { padding: "0" },
                },
            },
            MuiDialogTitle: {
                styleOverrides: {
                    root: { padding: "0px" },
                },
            },
            MuiDialogContent: {
                styleOverrides: {
                    root: {
                        paddingTop: "0px",
                        paddingBottom: "0px",
                    }
                }
            }
        },
    }), [isDarkMode]);

    const isSpDevice = useMediaQuery(theme.breakpoints.down('sm'));

    const [allEvents, setAllEvents] = useState([]);
    const [events, setEvents] = useState([]); // カレンダーに表示するフィルタリング後の予定
    const [roomMembers, setRoomMembers] = useState([]); // ルームメンバーのリスト
    const [tabIndex, setTabIndex] = useState(0);
    const [selectedHonbuids, setSelectedHonbuids] = useState([]);
    const [memberSearchText, setMemberSearchText] = useState('');  

    const [eventGuid, setEventGuid] = useState(0);

    // handleDateUnselect用に、選択中のselectionInfoを保持してもらう
    const [currentSelectionInfo, setCurrentSelectionInfo] = useState({});
    const [addEventDialog, setAddEventDialog] = useState(false); // 予定追加ダイアログを起動するか否か
    const [isEdit, setIsEdit] = useState(false);
    const [currentAddText, setCurrentAddText] = useState("");
    const [currentEventColorObj, setCurrentEventColorObj] = useState({
        name: "GCdefault",
        code: "#039BE5",
    });
    const [currentCanAllBeEdited, setCurrentCanAllBeEdited] = useState(false); // currentEventが作成者以外も編集・削除出来るか否かの状態を持つ
    const [tmpCurrentAllBeEdited, setTmpCurrentAllBeEdited] = useState(true); // チェックボックスの挙動で↑を変えると表示の処理が大変なので、こっちで拾ってAPIへ流し込む

    // const [eventColorAnchorEl, setEventColorAnchorEl] = useState(null);
    // 色選択メニューを配置するHTML要素を格納
    const anchorEl = useRef(null);

    

    const [eventColorMenuOpen, setEventColorMenuOpen] = useState(false);
    const [currentEventNotification, setCurrentEventNotification] = useState([]);
    const [circularProgressIsActive, setCircularProgressIsActive] = useState(false);
    const [linearProgressIsActive, setLinearProgressIsActive] = useState(false);
    const currentPageDateRef = useRef({ start: "", end: "" });
    const [errorDialog, setErrorDialog] = useState([false, ""]); // 認証失敗時・不正URL時等に起動
    const [helpOpen, setHelpOpen] = useState(false);
    const [confirmToDelete, setConfirmToDelete] = useState(false);
    const [eventShareDialog, setEventShareDialog] = useState(false);
    const [shareMyroomList, setShareMyroomList] = useState([]);
    const [shareGroupList, setShareGroupList] = useState([]);
    const [shareContactList, setShareContactList] = useState([]);
    const [shareRoomidList, setShareRoomidList] = useState([]);
    const [shareRoomnameList, setShareRoomnameList] = useState([]);
    const [shareListLoading, setShareListLoading] = useState(false);
    const [currentIsAnotherEvent, setCurrentIsAnotherEvent] = useState(false); // 予定ダイアログの編集許可で使う
    const [searchDialog, setSearchDialog] = useState(false);
    const [searchedEvents, setSearchedEvents] = useState([]);
    const [searchedMessage, setSearchedMessage] = useState("");
    const [invisibleSharedRoomidList, setInvisibleSharedRoomidList] = useState([]);
    const [holiday, setHoliday] = useState({}); // APIから取得した祝日json
    const [batchChecked, setBatchChecked] = useState([]);
    const [selectedBatchDates, setSelectedBatchDates] = useState([]); // 繰り返し登録があれば、選択された日付を格納
    const [batchOpen, setBatchOpen] = useState(false); // 繰り返し登録のダイアログ起動制御
    const [selectedBatchPeriod, setSelectedBatchPeriod] = useState("d"); //繰り返しダイアログ内、期間選択ボタンの状態を持つ 初期値は日の"d"
    const [batchOptions, setBatchOptions] = useState({}); // 繰り返し登録の◯日おきなどの選択肢 数が多いので、ダイアログ初回起動時に生成させる
    const [batchLimitDate, setBatchLimitDate] = useState(""); // 繰り返し登録の◯日おきなどの選択肢 数が多いので、ダイアログ初回起動時に生成させる


    const [currentAssignees, setCurrentAssignees] = useState([]); // [{honbuid: 1, name: "田中"}, ...]
    const [assigneeDialogOpen, setAssigneeDialogOpen] = useState(false); // メンバー選択画面の開閉
    const [assigneeSearchText, setAssigneeSearchText] = useState('');
    const handleCloseAssigneeDialog = () => {
        setAssigneeDialogOpen(false);
        setAssigneeSearchText('');
    };
    const [buttonTexts, setButtonTexts] = useState({
        list: "一覧",
        customSearch: "検索",
    });
    const [allAssignees, setAllAssignees] = useState([]); //  全イベントの担当者リスト
    const [userSearchMode, setUserSearchMode] = useState('creator');

    const calendarRef = useRef(null);

    const handlers = useSwipeable({
        onSwiped: (event) => {     
            if (event.dir === "Left") {
                // 左にスワイプしたときに発火するイベント
                // console.log("←←←左スワイプしたぞおおお")
                // 次の月へ
                calendarRef.current.calendar.next()
            }
            if (event.dir === "Right") {
                // 右にスワイプしたときに発火するイベント
                // console.log("右スワイプしたぞおおお→→→")
                // 前の月へ
                calendarRef.current.calendar.prev()
                
            }
        },
        trackMouse: false, //マウス操作でのスワイプを許可する場合はtrue
    });

    // vueで言うところのwatchのoldValみたいなやつ
    const prevSelectioninfo = usePrevious(currentSelectionInfo);


    // muiではテーマカラーしか使えないが、Fullcalendarではテーマカラーは使えないのでこれで変換😭
    const eventColorMember = [
        { name: "GCdefault", code: "#039BE5" },
        { name: "GCtomato", code: "#D50000" },
        { name: "GCflamingo", code: "#E67C73" },
        { name: "GCorange", code: "#F4511E" },
        { name: "GCbanana", code: "#F6BF26" },
        { name: "GCsage", code: "#33B679" },
        { name: "GCbasil", code: "#0B8043" },
        { name: "GCblueberry", code: "#3F51B5" },
        { name: "GClavender", code: "#7986CB" },
        { name: "GCgrape", code: "#8E24AA" },
        { name: "GCgraphite", code: "#616161" },
    ];

    // 初回起動時
    useEffect(() => {
        (async () => {
        if (paramhonbuid&&paramroomid ) {
            //初回のみロードのクルクル表示
            setCircularProgressIsActive(true);

            // 過去の版が localStorage に残した認証情報を掃除する（現在は使っていない）
            clearObsoleteCache();

            // 認証スキップ（ENABLE_AUTH = false）。/check を呼ばずに部屋を確定させる。
            // apikey はサーバ側が開発環境で照合しないため、中身は何でもよい。
            if (!ENABLE_AUTH) {
                sessionRef.current = {
                    honbuid: paramhonbuid,
                    roomid: paramroomid,
                    apikey: "dev",
                };
                await getRoomMembers();
                await getHolidays();
                await getAndApplyEvents(currentPageDateRef.current.start, currentPageDateRef.current.end);
                return;
            }

            // 認証処理
            //console.log("check start")
            await fetch(`/check?honbuid=${paramhonbuid}&roomid=${paramroomid}`)
                .then(async (response) => {
                    if (!response.ok) {
                        // HTTPエラーステータスの場合
                        const text = await response.text();
                        console.error(`HTTP ${response.status}: ${text}`);

                        // JSONとしてパースを試みる
                        try {
                            const errorJson = JSON.parse(text);
                            throw new Error(errorJson.message || errorJson.error || `HTTP ${response.status}`);
                        } catch (parseError) {
                            throw new Error(`Server error (${response.status}): ${text.substring(0, 200)}`);
                        }
                    }
                    return response.json();
                })
                .then(async (responseJson) => {
                    //console.log("check ok")
                    if (responseJson.status === 401) {
                        setErrorDialog([true,"auth"]);
                        return;
                    }
                    // 以降のAPI呼び出しが使う部屋・認証情報はここで確定させる。
                    // roomid は原則 paramroomid と同じ値が返るが、
                    // roomid=0（マイカレンダー）の時だけマイルームの roomid が返る。
                    // 返ってこなかった時もURLのroomidに倒す（別部屋の値には決してしない）。
                    const checkedRoomid = responseJson.roomid
                        ? String(responseJson.roomid)
                        : paramroomid;
                    sessionRef.current = {
                        honbuid: paramhonbuid,
                        roomid: checkedRoomid,
                        apikey: responseJson.key,
                    };
                    await getRoomMembers();
                    await getHolidays();
                    await getAndApplyEvents(currentPageDateRef.current.start, currentPageDateRef.current.end);
                }).catch((err) => {
                    console.error("check error", err);
                    setErrorDialog([true, "server"]);
                })
        } else {
            // 不正なURLです的な警告出す？
            //console.log("paramなし");
            setErrorDialog([true, "param"]);
        }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // currentSelectionInfo.startが動いた時、予定を削除
    useEffect(() => {
        if (prevSelectioninfo&&
            prevSelectioninfo.startStr &&
            currentSelectionInfo.startStr &&
            prevSelectioninfo.startStr !== currentSelectionInfo.startStr) {
                setCurrentEventNotification([]);
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSelectionInfo.start])


    // 月変更イベント
    const handleDateChange = async (event) => {
        const getStartDate = dayjs(event.start).format("YYYY-MM-DD 00:00:00");
        const getEndDate = dayjs(event.end).format("YYYY-MM-DD 00:00:00");
        if (!paramhonbuid) return; 
        if (currentPageDateRef.current.start !== ""
            && currentPageDateRef.current.start !== getStartDate) {
            // 月移動時 get実行
            getAndApplyEvents(getStartDate, getEndDate);
        }
        // 最後にcurrentPageDateRef更新
        currentPageDateRef.current = { start: getStartDate, end: getEndDate }
    };

    // 予定追加ダイアログ起動時
    const handleDateSelect = async(selectionInfo) => {
        // 予定作成時にドラッグして日付複数選択してきたか判定する
        // diffDates: end - start（日単位換算）
        dayjs.locale(ja);
        const diffDates = dayjs(selectionInfo.end).diff(
            dayjs(selectionInfo.start),
            "day"
        );

        // dateClickで呼び出した時（スマホ版）：start,startStrがない（変わりにdate,dateStr）
        // date,dateStrの内容でstart,startStrを作っておく
        if (selectionInfo.date&&selectionInfo.dateStr) {
            selectionInfo.start = selectionInfo.date;
            selectionInfo.startStr = selectionInfo.dateStr;
        }

        // ドラッグ選択でない時
        if (diffDates < 2) {
            // endの初期値をstartの1時間後に
            selectionInfo.end = dayjs(selectionInfo.start).add(1, "h").$d;
            // endStrも同様
            selectionInfo.endStr = dayjs(selectionInfo.start)
                .add(1, "h")
                .format("YYYY-MM-DD");
        } else {
            // endの初期値をendの1日前に
            selectionInfo.end = dayjs(selectionInfo.end).subtract(1, "d").$d;
            // endStrも同様
            selectionInfo.endStr = dayjs(selectionInfo.end)
                .subtract(1, "d")
                .format("YYYY-MM-DD");
        }

        // 予定ダイアログ起動時にshare設定も取ってきておく
        await handleShareGet(selectionInfo);
        setCurrentEventColorObj({ name: "GCdefault", code: "#039BE5" });
        setCurrentSelectionInfo(selectionInfo);
        setCurrentAddText("");
        setCurrentCanAllBeEdited(false);
        setTmpCurrentAllBeEdited(true);
        setCurrentAssignees([]);
        setAddEventDialog(true);
    };

    // 予定追加ダイアログ脱出時
    const handleDateUnselect = () => {
        setAddEventDialog(false);
        setCurrentSelectionInfo({});
        setCurrentAddText("");
        setCurrentCanAllBeEdited(false);
        setTmpCurrentAllBeEdited(true);
        setCurrentAssignees([]);
        setCurrentEventColorObj({ name: "GCdefault", code: "#039BE5" });
        setCurrentEventNotification([]);
        setShareGroupList([]);
        setShareContactList([]);
        setShareRoomidList([]);
        setShareRoomnameList([]);
        setCurrentIsAnotherEvent(false);
        setInvisibleSharedRoomidList([]);
        setIsEdit(false);
        // ↓繰り返し系
        setSelectedBatchPeriod("d");
        setBatchLimitDate("");
        setSelectedBatchDates([]);
        setBatchChecked([]);
    };

    // ヘルプパネル: ?キー と postMessage { type: "openHelp" } で開閉
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "?" && !["INPUT", "TEXTAREA"].includes(event.target.tagName)) {
                setHelpOpen((prev) => !prev);
            }
        };
        const handleMessage = (event) => {
            if (event.data?.type === "openHelp") {
                setHelpOpen(true);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    // 絞り込み
    useEffect(() => {
        if (selectedHonbuids.length > 0) {
            if (userSearchMode === 'creator') {
                // 作成者・更新者で絞り込み
                const filtered = allEvents.filter(event => selectedHonbuids.includes(String(event.honbuid)));
                setEvents(filtered);
            } else {
                // 担当者で絞り込み
                const targetEventIds = allAssignees
                    .filter(a => selectedHonbuids.includes(String(a.honbuid)))
                    .map(a => String(a.eventid));
                const filtered = allEvents.filter(event => targetEventIds.includes(String(event.id)));
                setEvents(filtered);
            }
        } else {
            setEvents(allEvents);
        }
    }, [selectedHonbuids, allEvents, userSearchMode, allAssignees]);

    const handleToggleMember = (honbuid) => {
        const currentIndex = selectedHonbuids.indexOf(honbuid);
        const newSelected = [...selectedHonbuids];
        if (currentIndex === -1) {
            newSelected.push(honbuid);
        } else {
            newSelected.splice(currentIndex, 1);
        }
        setSelectedHonbuids(newSelected);
    };

    const handleClearAllSelection = () => {
        setSelectedHonbuids([]);
    };


    const getRoomMembers = async () => {
        const LSroomid = sessionRef.current.roomid;
        const LSapikey = sessionRef.current.apikey;
        // /check が終わるまでは apikey が無い（401になるだけなので呼ばない）
        if (!LSapikey) return;

        try {
            const response = await fetch(`/room/${LSroomid}/members`, {
                headers: {
                    'apikey': LSapikey 
                }
            });
            if (!response.ok) {
                throw new Error(`メンバーリストの取得に失敗しました: ${response.status}`);
            }
            const members = await response.json();
            setRoomMembers(members);

        } catch (error) {
            console.error("Failed to fetch room members:", error);
            toast.error("メンバーリストの取得に失敗しました。");
        }
    };

    // fetch get →ローカルのeventsに反映
    const getAndApplyEvents = async(forward,before) => {
        //console.log("get start")
        const LShonbuid = sessionRef.current.honbuid
        const LSroomid = sessionRef.current.roomid
        // /check が終わるまでは apikey が無い。ここで呼んでも401で空の結果を
        // 描いてしまうだけなので、認証完了後の呼び出しに任せる
        // （月移動などで /check と競合しうる）
        if (!sessionRef.current.apikey) return;
        setLinearProgressIsActive(true);

        // get範囲は、カレンダー表示始点-35日(5週間)～カレンダー表示終点+35日(5週間)
        const extendedForward = dayjs(forward).subtract(35, 'd').format("YYYY-MM-DD 00:00:00");
        const extendedBefore = dayjs(before).add(35, 'd').format("YYYY-MM-DD 00:00:00");

        //apikeyをheaderに混ぜてget
        if (paramhonbuid) {
            await fetch(`/events?honbuid=${LShonbuid}&roomid=${LSroomid}&forward=${extendedForward}&before=${extendedBefore}`,
                { headers: { apikey: sessionRef.current.apikey } }
            ).then((response) => response.json()
            ).then((responseJson) => {
                handleApplyEvent(responseJson.eventslist, responseJson.notislist, "events", responseJson.assigneeslist)
                //console.log("get ok")
            }).catch((err) => {
                console.log("get error", err);
            })
            setCircularProgressIsActive(false);
            setLinearProgressIsActive(false);
        }
    }

    // get取得した情報をもとに、stateのevents更新
    const handleApplyEvent = (eventslist, notislist, target, assigneeslist = []) => {
        let tmpevents = [];
        for (const event of eventslist) {
            //eventのidでnotisList(通知リスト)を走査
            const filtednotis = notislist.filter(noti => 
                noti.notiEventid === event.id
            )
            // events内のnotificationに合わせた形に整える [{time:"YYYY-MM-DD HH:mm"},...]
            const formatedfiltednotis = [];
            if (filtednotis.length > 0) {
                for (const filtednoti of filtednotis) {
                    formatedfiltednotis.push({
                        time: dayjs(filtednoti.notification).format("YYYY-MM-DD HH:mm")
                    })
                }
            }
            // allDayの値によってstart,endをformatする
            // Fullcalendarに渡す時は特定の形にformatする必要がある
            let formatedstart = "";
            let formatedend = "";
            if (event.allDay === "1") {
                // 全日のときはYYYY-MM-DD
                formatedstart = dayjs(event.start).format("YYYY-MM-DD");
                formatedend = dayjs(event.end).format("YYYY-MM-DD");
            } else {
                // 時間指定のときはYYYY-MM-DDTHH:mm
                formatedstart = dayjs(event.start).format("YYYY-MM-DDTHH:mm");
                formatedend = dayjs(event.end).format("YYYY-MM-DDTHH:mm");
            }
            tmpevents.push({
                id: event.id,
                honbuid: event.honbuid,
                name: event.name,
                title: event.title,
                start: formatedstart,
                end: formatedend,
                allDay: event.allDay === "1" ? true:false,
                backgroundColor: event.backgroundColor,
                eventColorObj: JSON.parse(event.eventColorObj),
                borderColor: event.borderColor,
                addText: event.addText,
                canAllBeEdited: event.canAllBeEdited ==="1" ?true:false,
                notification: formatedfiltednotis
            })
        }
        if (target === "events") {
            // tmpeventsでstateのeventsを一気に更新
            setAllEvents(tmpevents);
            setAllAssignees(assigneeslist);
        } else if (target === "searchedEvents") {
            setSearchedEvents(tmpevents);
        }
    }

    // 配列オブジェクトの重複削除
    const uniqueObjInArr = (argObjInArr) => {
        return Array.from(
            new Map(argObjInArr.map((obj) => [obj.time, obj])).values()
        );
    }

    // 予定を追加
    const handleAddEvent = async () => {
        // Ⅰ.終日 開始-終了 → id,title,start,end,allDay (start,endは'YYYY-MM-DD')
        // Ⅱ.時間追加 開始-終了 → id,title,start,end,allDay (start,endは'YYYY-MM-DDTHH:MM:SS')

        // allDayの時のみ、カレンダーの描画が直感的ではない（endが1日前倒しで表示される）ので、
        // setEvent時にendを1日足す（編集などでcurrentに取り込むときには1日引いて取得するようにする）


        let requestOptions = {};

        // 共有設定の登録がある時、（shareRoomidList.length > 0）タイトルの頭に🔗を付ける
        const eventTitleHeader = shareRoomidList.length > 0 ? "🔗" : "";

        if (currentSelectionInfo.allDay) {
            // Ⅰのパターン
            setEvents([
                ...events,
                {
                    id: createEventId(),
                    // groupId もつけれるみたい 後々必要になって来るかも
                    // honbuid
                    honbuid: paramhonbuid,
                    title: eventTitleHeader + (currentSelectionInfo.title
                        ? currentSelectionInfo.title
                        : "(タイトル未入力)"),
                    start: dayjs(currentSelectionInfo.start).format("YYYY-MM-DD"),
                    end: dayjs(currentSelectionInfo.end).add(1, "d").format("YYYY-MM-DD"),
                    allDay: currentSelectionInfo.allDay,
                    backgroundColor: currentEventColorObj.code,
                    eventColorObj: currentEventColorObj,
                    // borderColor: "#eceff1",
                    borderColor: currentEventColorObj.code,
                    addText: currentAddText,
                    canAllBeEdited: tmpCurrentAllBeEdited,
                    notification: uniqueObjInArr(currentEventNotification),
                },
            ]);

            requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    //id: createEventId(),
                    groupId: sessionRef.current.roomid,
                    honbuid: paramhonbuid,
                    title: eventTitleHeader + (currentSelectionInfo.title
                        ? currentSelectionInfo.title
                        : "(タイトル未入力)"),
                    start: dayjs(currentSelectionInfo.start).format("YYYY/MM/DD 00:00:00"),
                    end: dayjs(currentSelectionInfo.end).add(1, "d").format("YYYY/MM/DD 00:00:00"),
                    allDay: currentSelectionInfo.allDay ? "1" : "0",
                    backgroundColor: currentEventColorObj.code,
                    eventColorObj: JSON.stringify(currentEventColorObj),
                    borderColor: currentEventColorObj.code,
                    addText: currentAddText,
                    canAllBeEdited: tmpCurrentAllBeEdited ? "1" : "0",
                    notifications: uniqueObjInArr(currentEventNotification),
                    assignees: currentAssignees
                })
            };
        } else {
            // Ⅱのパターン
            setEvents([
                ...events,
                {
                    id: createEventId(),
                    // groupId もつけれるみたい 後々必要になって来るかも
                    honbuid: paramhonbuid,
                    title: eventTitleHeader + (currentSelectionInfo.title
                        ? currentSelectionInfo.title
                        : "(タイトル未入力)"),
                    start: dayjs(currentSelectionInfo.start).format("YYYY-MM-DDTHH:mm"),
                    end: dayjs(currentSelectionInfo.end).format("YYYY-MM-DDTHH:mm"),
                    allDay: currentSelectionInfo.allDay,
                    backgroundColor: currentEventColorObj.code,
                    eventColorObj: currentEventColorObj,
                    // borderColor: "#eceff1",
                    borderColor: currentEventColorObj.code,
                    addText: currentAddText,
                    canAllBeEdited: tmpCurrentAllBeEdited,
                    notification: uniqueObjInArr(currentEventNotification),
                },
            ]);

            requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    //id: createEventId(),
                    groupId: sessionRef.current.roomid,
                    honbuid: paramhonbuid,
                    title: eventTitleHeader + (currentSelectionInfo.title
                        ? currentSelectionInfo.title
                        : "(タイトル未入力)"),
                    start: dayjs(currentSelectionInfo.start).format("YYYY/MM/DD HH:mm:00"),
                    end: dayjs(currentSelectionInfo.end).format("YYYY/MM/DD HH:mm:00"),
                    allDay: currentSelectionInfo.allDay ? "1" : "0",
                    backgroundColor: currentEventColorObj.code,
                    eventColorObj: JSON.stringify(currentEventColorObj),
                    // borderColor: "#eceff1",
                    borderColor: currentEventColorObj.code,
                    addText: currentAddText,
                    canAllBeEdited: tmpCurrentAllBeEdited ? "1" : "0",
                    notifications: uniqueObjInArr(currentEventNotification),
                    assignees: currentAssignees
                })
            };
        }

        //console.log("post insert start")
        await fetch("/events", requestOptions
        ).then((response) => response.json()
        ).then(async (responseJson) => {
            // 新しいidを使い、公開設定を再度登録
            await upRoomidToShareWithNewEventid(responseJson, shareRoomidList);
            // ブラウザ版の時、post成功したらsnackbar表示
            if (!isSpDevice) {
                toast.success('予定を追加しました。')
            }
            // 複製設定がある時、responseJsonの idを元に batchAPI走らせる
            if (selectedBatchDates.length > 0) {
                await insertBatch(responseJson);
            }
            // post成功したらget
            getAndApplyEvents(currentPageDateRef.current.start, currentPageDateRef.current.end);
        }).catch((err) => {
            console.log("post insert error", err);
        }).finally(() => {
            handleDateUnselect(); // 最後に脱出時の処理を入れる
        })

        
    };

    // idをもとにeventsの要素削除
    const deleteEvent = async() => {
        // state event delete
        setEvents(events.filter((event) => event.id !== currentSelectionInfo.id));

        // to鯖 delete
        const deleteParam = {
            eventid: currentSelectionInfo.id,
            honbuid: paramhonbuid,
            roomid: sessionRef.current.roomid
        }
        const parameter = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(deleteParam)
            }
        const result = await fetch("/events", parameter).then((response) => {
            return response.json();
        });
        if (result && !isSpDevice) {
            // ブラウザ版の時、delete成功したらsnackbar表示
            toast.success('予定を削除しました。')
        }
        getAndApplyEvents(currentPageDateRef.current.start, currentPageDateRef.current.end);
    };

    const handleDeleteEvent = () => {
        deleteEvent();
        setSearchedEvents([]);
        setSearchedMessage("");
        setSearchDialog(false);

        handleDateUnselect();
        setConfirmToDelete(false);
    };

    // Eventsを編集（実質DeleteInsert）
    const handleEditEvent = async() => {
        const eventTitleHeader = shareRoomidList.length > 0 ? "🔗" : "" ;
        let requestOptions = {};


        if (currentSelectionInfo.allDay) {
            // Ⅰのパターン
            setEvents([
                ...events.filter((event) => event.id !== currentSelectionInfo.id),
                {
                    id: createEventId(),
                    // groupId もつけれるみたい 後々必要になって来るかも
                    honbuid: paramhonbuid,
                    title: eventTitleHeader + (currentSelectionInfo.title
                        ? currentSelectionInfo.title
                        : "(タイトル未入力)"),
                    start: dayjs(currentSelectionInfo.start).format("YYYY-MM-DD"),
                    end: dayjs(currentSelectionInfo.end).add(1, "d").format("YYYY-MM-DD"),
                    allDay: currentSelectionInfo.allDay,
                    backgroundColor: currentEventColorObj.code,
                    eventColorObj: currentEventColorObj,
                    // borderColor: "#eceff1",
                    borderColor: currentEventColorObj.code,
                    addText: currentAddText,
                    canAllBeEdited: tmpCurrentAllBeEdited,
                    notification: uniqueObjInArr(currentEventNotification),
                },
            ]);
            // id付きでpost 鯖側でdeleteinsert
            requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: currentSelectionInfo.id,
                    groupId: sessionRef.current.roomid,
                    honbuid: paramhonbuid,
                    title: eventTitleHeader + (currentSelectionInfo.title
                        ? currentSelectionInfo.title
                        : "(タイトル未入力)"),
                    start: dayjs(currentSelectionInfo.start).format("YYYY/MM/DD 00:00:00"),
                    end: dayjs(currentSelectionInfo.end).add(1, "d").format("YYYY/MM/DD 00:00:00"),
                    allDay: currentSelectionInfo.allDay ? "1" : "0",
                    backgroundColor: currentEventColorObj.code,
                    eventColorObj: JSON.stringify(currentEventColorObj),
                    borderColor: currentEventColorObj.code,
                    addText: currentAddText,
                    canAllBeEdited: tmpCurrentAllBeEdited ? "1" : "0",
                    notifications: uniqueObjInArr(currentEventNotification),
                    assignees: currentAssignees
                })
            };
        } else {
            // Ⅱのパターン
            setEvents([
                ...events.filter((event) => event.id !== currentSelectionInfo.id),
                {
                    id: createEventId(),
                    // groupId もつけれるみたい 後々必要になって来るかも
                    honbuid: paramhonbuid,
                    title: eventTitleHeader + (currentSelectionInfo.title
                        ? currentSelectionInfo.title
                        : "(タイトル未入力)"),
                    start: dayjs(currentSelectionInfo.start).format("YYYY-MM-DDTHH:mm"),
                    end: dayjs(currentSelectionInfo.end).format("YYYY-MM-DDTHH:mm"),
                    allDay: currentSelectionInfo.allDay,
                    backgroundColor: currentEventColorObj.code,
                    eventColorObj: currentEventColorObj,
                    // borderColor: "#eceff1",
                    borderColor: currentEventColorObj.code,
                    addText: currentAddText,
                    canAllBeEdited: tmpCurrentAllBeEdited,
                    notification: uniqueObjInArr(currentEventNotification),
                },
            ]);
            requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: currentSelectionInfo.id,
                    groupId: sessionRef.current.roomid,
                    honbuid: paramhonbuid,
                    title: eventTitleHeader + (currentSelectionInfo.title
                        ? currentSelectionInfo.title
                        : "(タイトル未入力)"),
                    start: dayjs(currentSelectionInfo.start).format("YYYY/MM/DD HH:mm:00"),
                    end: dayjs(currentSelectionInfo.end).format("YYYY/MM/DD HH:mm:00"),
                    allDay: currentSelectionInfo.allDay ? "1" : "0",
                    backgroundColor: currentEventColorObj.code,
                    eventColorObj: JSON.stringify(currentEventColorObj),
                    // borderColor: "#eceff1",
                    borderColor: currentEventColorObj.code,
                    addText: currentAddText,
                    canAllBeEdited: tmpCurrentAllBeEdited ? "1" : "0",
                    notifications: uniqueObjInArr(currentEventNotification),
                    assignees: currentAssignees
                })
            };
        }

        //console.log("post deleteinsert start")
        await fetch("/events", requestOptions
        ).then((response) => response.json()
        ).then(async (responseJson) => {
            // ブラウザ版の時、post成功したらsnackbar表示
            // 新しいidを使い、公開設定を再度登録
            await upRoomidToShareWithNewEventid(responseJson, shareRoomidList);
            if (!isSpDevice) {
                toast.success('予定を変更しました。')
            }
            // 複製設定がある時、responseJsonの idを元に batchAPI走らせる
            if (selectedBatchDates.length > 0) {
                await insertBatch(responseJson);
            }
            // post成功したらget
            getAndApplyEvents(currentPageDateRef.current.start, currentPageDateRef.current.end);
        }).catch((err) => {
            console.log("post deleteinsert error", err);
        }).finally(() => {
            // 最後に脱出処理
            setSearchedEvents([]);
            setSearchedMessage("");
            setSearchDialog(false);
            handleDateUnselect();
        })
  
    };

    // currentSelectionInfo（選択中の予定）の内容を編集する
    // type(String)ごとに処理を変える
    const updateCurrentSelectionInfo = (type, ele) => {
        if (type === "start") {
            let addOneHourEle = ele.add(1, "hour");
            if (currentSelectionInfo.allDay) {
                setCurrentSelectionInfo((prevInfo) => ({
                    ...prevInfo,
                    start: ele.$d,
                    startStr: ele.format("YYYY-MM-DD"),
                    // endもズラしておく
                    end: addOneHourEle.$d,
                    endStr: addOneHourEle.format("YYYY-MM-DD"),
                }));
            } else {
                setCurrentSelectionInfo((prevInfo) => ({
                    ...prevInfo,
                    start: ele.$d,
                    startStr: ele.format("YYYY-MM-DDTHH:mm"),
                    // endもズラしておく
                    end: addOneHourEle.$d,
                    endStr: addOneHourEle.format("YYYY-MM-DDTHH:mm"),
                }));
            }
        }
        if (type === "end") {
            if (currentSelectionInfo.allDay) {
                setCurrentSelectionInfo((prevInfo) => ({
                    ...prevInfo,
                    end: ele.$d,
                    endStr: ele.format("YYYY-MM-DD"),
                }));
            } else {
                setCurrentSelectionInfo((prevInfo) => ({
                    ...prevInfo,
                    end: ele.$d,
                    endStr: ele.format("YYYY-MM-DDTHH:mm"),
                }));
            }
        }
    };

    // CurrentSelectionInfoのAllDayをひっくり返す（時間追加のチェックボックスの制御）
    const handleCurrentAllDay = (event) => {
        // 時間指定チェック入ったとき(event.target.checked=true)、HH:mmは現在付近にする。
        let tmpstartDayjs = {};
        let tmpendDayjs = {};
        if (event.target.checked) {
            const now = dayjs();
            let tmphour = now.hour()
            let tmpminute = Math.ceil(now.minute() / 10) * 10;
            tmpstartDayjs = dayjs(currentSelectionInfo.start).hour(tmphour).minute(tmpminute);
            tmpendDayjs = tmpstartDayjs.add(1, "hour");
            // console.log("tmp", tmpstartDayjs.$d, tmpendDayjs.$d);
        } else {
            tmpstartDayjs = dayjs(currentSelectionInfo.start);
            tmpendDayjs = dayjs(currentSelectionInfo.end);
        }
        // allDayはtrue:全日、false:時間指定なので、反転して登録する
        setCurrentSelectionInfo((prevInfo) => ({
            ...prevInfo,
            start: tmpstartDayjs.$d,
            startStr: event.target.checked ? tmpstartDayjs.format("YYYY-MM-DDTHH:mm"):tmpstartDayjs.format("YYYY-MM-DD"),
            // endもズラしておく
            end: tmpendDayjs.$d,
            endStr: event.target.checked ? tmpendDayjs.format("YYYY-MM-DDTHH:mm"):tmpendDayjs.format("YYYY-MM-DD"),
            allDay: !event.target.checked,
        }));
    };

    // 「他メンバーの編集を許可」のチェックボックスを押した時
    const handleChangeCanAllBeEdited = (event) => {
        setTmpCurrentAllBeEdited(event.target.checked);
    }


    // 作成済みの予定を押した時の動き
    const handleEventClick = async (clickInfo) => {
        //console.log(clickInfo);
        setIsEdit(true);
        dayjs.locale(ja);

        // tmpEventにデータ取り出して準備する
        // 検索ダイアログfalseならeventsからコピー、trueならsearchedEventsからコピー

        let tmpEvent = {};
        if (!searchDialog) {
            tmpEvent = _.cloneDeep(
                events.find((ele) => ele.id === clickInfo.event.id)
            );
        } else {
            // 検索ダイアログから来た時はeventを連れてくるので、idnomi 

            tmpEvent = _.cloneDeep(
                searchedEvents.find((ele) => ele.id === clickInfo.id)
            );
        }

        // tmpEvent.allDayがTrueのとき、カレンダー表示のために1日足していた時間を戻す
        if (tmpEvent.allDay) {
            tmpEvent.end = dayjs(tmpEvent.end).subtract(1, "d").format("YYYY-MM-DD");
        }

        //console.log("hogehogehogehoge", unicodeSubstring(tmpEvent.title, 0, 1), unicodeSubstring(tmpEvent.title, 0, 1) === "🔗")


        // tmpEvent.titleの先頭に🔗がついていたら消す
        if (unicodeSubstring(tmpEvent.title, 0, 1) === "🔗") {
            tmpEvent.title = tmpEvent.title.replace("🔗","");
        }

        // tmpEvent.titleが(タイトル未入力)のとき、titleを空白に
        if (tmpEvent.title === "(タイトル未入力)") {
            tmpEvent.title = "";
        }
        // console.log("tmpevent",tmpEvent)

        if (tmpEvent.honbuid === sessionRef.current.honbuid.toString()) {
            //console.log("本人だよ")
            setCurrentIsAnotherEvent(false);
        } else {
            //console.log("本人じゃないよ")
            setCurrentIsAnotherEvent(true);
        }
        

        // 予定ダイアログ起動時にshare設定も取ってきておく
        handleShareGet(tmpEvent);

        setCurrentSelectionInfo(tmpEvent);
        setCurrentAddText(tmpEvent.addText);
        setCurrentCanAllBeEdited(tmpEvent.canAllBeEdited);
        setTmpCurrentAllBeEdited(tmpEvent.canAllBeEdited);
        setCurrentEventColorObj(tmpEvent.eventColorObj);
        setCurrentEventNotification(tmpEvent.notification);

        // 担当者リストを取得
        try {
            const res = await fetch(`/events/assignees?eventid=${clickInfo.event.id}`);

            if (res.ok) {
                const assigneeData = await res.json();
                setCurrentAssignees(assigneeData || []);
            } else {
                console.error("担当者取得失敗:", res.status);
                setCurrentAssignees([]);
            }
        } catch (error) {
            console.error("通信エラー:", error);
            setCurrentAssignees([]);
        }
        setAddEventDialog(true);
    };

    // 絵文字対応のsubstring すぐ上で使ってる
    const unicodeSubstring = (str, start, end) => {
        const reg = new RegExp(`^.{${start}}(.{0,${end - start}})`, 'u')
        return str.match(reg)?.[1]
    }



    // eventがリサイズされた時
    // リサイズ後のデータでevents更新
    // idをもとに、start,endに更新かける
    // 時間指定のあるイベントはリサイズ不可
    const handleEventResize = async (resizedEvent) => {
        console.log("handleEventResize", resizedEvent);

        if (resizedEvent.event.extendedProps.canAllBeEdited === false
            && resizedEvent.event.extendedProps.honbuid !== sessionRef.current.honbuid.toString()) {
            //console.log("リサイズ 本人じゃないよ")
            if (!isSpDevice) {
                //setSnackbarState([true, "予定を変更しました。"]);
                toast.error('この予定は作成者本人のみ変更が可能です。')
            }
            getAndApplyEvents(currentPageDateRef.current.start, currentPageDateRef.current.end);
            handleDateUnselect();
            return;
        }

        const LShonbuid = sessionRef.current.honbuid
        const payloadeventid = resizedEvent.event.id
        const targetAssignees = allAssignees.filter(a => String(a.eventid) === String(resizedEvent.event.id));
        await fetch(`/share?honbuid=${LShonbuid}&eventid=${payloadeventid}`,
        ).then((response) => response.json()
        ).then(async (responseJson) => {
            //console.log("share get ok", responseJson);
            //let tmpGroupList = responseJson.ret.filter(e => e.isgroup === "1")
            //let tmpContactList = responseJson.ret.filter(e => e.isgroup === "0")
            let tmpShareList = responseJson.ret;

            setShareListLoading(false);
            setEvents((prevState) =>
                prevState.map((obj) =>
                    obj.id === resizedEvent.event.id
                        ? {
                            ...obj,
                            start: resizedEvent.event.startStr,
                            end: resizedEvent.event.endStr,
                        }
                        : obj
                )
            );
            // id付きでpost 鯖側でdeleteinsert
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: resizedEvent.event.id,
                    groupId: sessionRef.current.roomid,
                    honbuid: LShonbuid,
                    title: resizedEvent.event.title,
                    start: dayjs(resizedEvent.event.startStr).format("YYYY/MM/DD 00:00:00"),
                    end: dayjs(resizedEvent.event.endStr).format("YYYY/MM/DD 00:00:00"),
                    allDay: resizedEvent.event.allDay ? "1" : "0",
                    backgroundColor: resizedEvent.event.backgroundColor,
                    eventColorObj: JSON.stringify(resizedEvent.event.extendedProps.eventColorObj),
                    borderColor: resizedEvent.event.borderColor,
                    addText: resizedEvent.event.extendedProps.addText,
                    canAllBeEdited: resizedEvent.event.extendedProps.canAllBeEdited?"1":"0",
                    notifications: uniqueObjInArr(resizedEvent.event.extendedProps.notification),
                    assignees: targetAssignees
                })
            };
            //console.log("post deleteinsert start")
            fetch("/events", requestOptions
            ).then((response) => response.json()
            ).then((responseJson) => {
                // 新しいidを使い、公開設定を再度登録
                //let filtedGroupList = tmpGroupList.filter(ele => { return ele.isshared === "1" })
                //let filtedContactList = tmpContactList.filter(ele => { return ele.isshared === "1" })
                let issharedList = tmpShareList.filter(ele => { return ele.isshared === "1" })
                let retRoomidList = [];
                for (const ele of issharedList) {
                    retRoomidList.push({ roomid: ele.roomid })
                }
                upRoomidToShareWithNewEventid(responseJson, retRoomidList);
                if (!isSpDevice) {
                    //setSnackbarState([true, "予定を変更しました。"]);
                    toast.success('予定を変更しました。')
                }
                // post成功したらget
                getAndApplyEvents(currentPageDateRef.current.start, currentPageDateRef.current.end);
                handleDateUnselect();
            }).catch((err) => {
                console.log("resize post deleteinsert error", err);
                handleDateUnselect();
            })
        }).catch((err) => {
            setShareListLoading(false);
            console.log("share get error", err);
            handleDateUnselect();
        })
    };

    // eventがドラッグ＆ドロップされた時
    // ドロップ後のデータでevents更新
    // idをもとに、start,endに更新かける
    const handleEventDrop = async(DropedEvent) => {
        // console.log("handleEventDrop", DropedEvent);

        if (DropedEvent.event.extendedProps.canAllBeEdited === false
            && DropedEvent.event.extendedProps.honbuid !== sessionRef.current.honbuid.toString()) {
            //console.log("ドロップ 本人じゃないよ")
            if (!isSpDevice) {
                //setSnackbarState([true, "予定を変更しました。"]);
                toast.error('この予定は作成者本人のみ変更可能です。')
            }
            getAndApplyEvents(currentPageDateRef.current.start, currentPageDateRef.current.end);
            handleDateUnselect();
            return;
        }

        const LShonbuid = sessionRef.current.honbuid
        const payloadeventid = DropedEvent.event.id
        const targetAssignees = allAssignees.filter(a => String(a.eventid) === String(DropedEvent.event.id));
        await fetch(`/share?honbuid=${LShonbuid}&eventid=${payloadeventid}`,
        ).then((response) => response.json()
        ).then(async(responseJson) => {
            //console.log("share get ok", responseJson);
            //let tmpGroupList = responseJson.ret.filter(e => e.isgroup === "1")
            //let tmpContactList = responseJson.ret.filter(e => e.isgroup === "0")
            let tmpShareList = responseJson.ret;

            setShareListLoading(false);

            setEvents((prevState) =>
                prevState.map((obj) =>
                    obj.id === DropedEvent.event.id
                        ? {
                            ...obj,
                            start: DropedEvent.event.startStr,
                            end: DropedEvent.event.endStr,
                        }
                        : obj
                )
            );
            // id付きでpost 鯖側でdeleteinsert
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: DropedEvent.event.id,
                    groupId: sessionRef.current.roomid,
                    honbuid: LShonbuid,
                    title: DropedEvent.event.title,
                    start: dayjs(DropedEvent.event.startStr).format("YYYY/MM/DD HH:mm:ss"),
                    end: dayjs(DropedEvent.event.endStr).format("YYYY/MM/DD HH:mm:ss"),
                    allDay: DropedEvent.event.allDay ? "1" : "0",
                    backgroundColor: DropedEvent.event.backgroundColor,
                    eventColorObj: JSON.stringify(DropedEvent.event.extendedProps.eventColorObj),
                    borderColor: DropedEvent.event.borderColor,
                    addText: DropedEvent.event.extendedProps.addText,
                    canAllBeEdited: DropedEvent.event.extendedProps.canAllBeEdited?"1":"0",
                    notifications: uniqueObjInArr(DropedEvent.event.extendedProps.notification),
                    assignees: targetAssignees
                })
            };
            //console.log("post deleteinsert start")
            fetch("/events", requestOptions
            ).then((response) => response.json()
            ).then((responseJson) => {
                    //console.log("post deleteinsert ok", responseJson);
                    // 新しいidを使い、公開設定を再度登録
                    //let filtedGroupList = tmpGroupList.filter(ele => { return ele.isshared === "1" })
                    //let filtedContactList = tmpContactList.filter(ele => { return ele.isshared === "1" })
                    let issharedList = tmpShareList.filter(ele => { return ele.isshared === "1" })
                    let retRoomidList = [];
                    for (const ele of issharedList) {
                        retRoomidList.push({ roomid: ele.roomid })
                    }
                    upRoomidToShareWithNewEventid(responseJson, retRoomidList);
                    if (!isSpDevice) {
                        //setSnackbarState([true, "予定を変更しました。"]);
                        toast.success('予定を変更しました。')
                    }
                    // post成功したらget
                    getAndApplyEvents(currentPageDateRef.current.start, currentPageDateRef.current.end);
                    handleDateUnselect();
            }).catch((err) => {
                console.log("drop post deleteinsert error", err);
                handleDateUnselect();
            })

        }).catch((err) => {
            setShareListLoading(false);
            console.log("share get error", err);
            handleDateUnselect();
        })
    };

    // 通知系
    // 通知時間追加
    const handleAddNotification = () => {
        setCurrentEventNotification([
            ...currentEventNotification, {"time":
                notificationConfirmFuture()}
        ]);
        
    };
    
    // 通知の初期値をチェック 現在時刻より前になってしまった時、現在時刻10分単位繰上の時間に更新
    const notificationConfirmFuture = () => {
        const currentDateTime = dayjs();
        // 全日の時、デフォの値は予定開始の1日前の午前9時
        // 時間指定の時、デフォの値は予定開始の10分前
        const defaultDateTime = currentSelectionInfo.allDay
            ? dayjs(currentSelectionInfo.start).subtract(1, "day").hour(9)
            : dayjs(currentSelectionInfo.start).subtract(10, "minute")
        // console.log(defaultDateTime.isBefore(currentDateTime));
        if (defaultDateTime.isBefore(currentDateTime)) {
            // 規定の初期値が過去の時間だった場合、初期値を設定し直す            
            const recalculateDateTime = currentSelectionInfo.allDay
                ? currentDateTime.hour(currentDateTime.hour() + 1).minute(0)
                : currentDateTime.minute(Math.ceil(currentDateTime.minute() / 10) * 10);
            //console.log("recalculateDateTime", recalculateDateTime.format("YYYY-MM-DD HH:mm"));
            return recalculateDateTime.format("YYYY-MM-DD HH:mm");
        } else {
            return defaultDateTime.format("YYYY-MM-DD HH:mm");
        }
    }


    // 通知時間変更
    const handleUpdateNotification = (selectedDate, targetIndex) => {
        // targetindexをもとに更新
        setCurrentEventNotification((prevNotification) =>
            prevNotification.map((value, index) =>
                index === targetIndex
                    ? { "time": dayjs(selectedDate).format("YYYY-MM-DD HH:mm") }
                    : value
            )
        );
    };

    // 通知削除
    const handleDeleteNotification = (targetIndex) => {
        // targetindexをもとに削除
        setCurrentEventNotification((prevNotification) =>
            prevNotification.filter((value, index) => index !== targetIndex)
        );
    };

    // 色選択系
    const handleEventColorMenuOpen = () => {
        setEventColorMenuOpen(true);
    };
    const handleEventColorMenuClose = () => {
        setEventColorMenuOpen(false);
    };
    const handleEventColorIsChanged = (eventcolor) => {
        //console.log(eventcolor);
        setCurrentEventColorObj(eventcolor);
        handleEventColorMenuClose();
    };

    // share系
    // sharedialog開いた時、参加中のルームリストを取得
    const handleOpenEventShareDialog = async() => {
        await handleShareGet(currentSelectionInfo);
        setEventShareDialog(true);
    }

    // 参加中のグループ・コンタクトの情報 + share済かget → stateにset
    const handleShareGet = async(selectioninfo) => {
        setShareListLoading(true);
        const LShonbuid = sessionRef.current.honbuid
        const LSroomid = sessionRef.current.roomid
        const payloadeventid = 'id' in selectioninfo ? selectioninfo.id : "0"
        await fetch(`/share?honbuid=${LShonbuid}&eventid=${payloadeventid}`,
        ).then((response) => response.json()
        ).then((responseJson) => {
            console.log("share get ok", responseJson);
            // 今の部屋はリストに含めない 公開設定が登録された場合、合わせて今の部屋の公開設定も登録している
            // マイルームのみグループから分離
            let tmpMyroomList = responseJson.ret.filter(e => e.ismyroom === "1" && e.roomid !== LSroomid.toString())
            let tmpGroupList = responseJson.ret.filter(e => e.isgroup === "1" && e.ismyroom === "0" && e.roomid !== LSroomid.toString())
            let tmpContactList = responseJson.ret.filter(e => e.ismyroom === "0" && e.isgroup === "0" && e.roomid !== LSroomid.toString())
            let tmpinvisibleSharedRoomidList = responseJson.invisibleSharedRoomidList;
            setShareMyroomList(tmpMyroomList)
            setShareGroupList(tmpGroupList)
            setShareContactList(tmpContactList)
            setShareListLoading(false);
            shareRoomidFilterAndFormat(tmpMyroomList, tmpGroupList, tmpContactList);
            setInvisibleSharedRoomidList(tmpinvisibleSharedRoomidList);
            console.log("hoge", tmpinvisibleSharedRoomidList);
        }).catch((err) => {
            setShareListLoading(false);
            console.log("share get error", err);
        })
        
    }


    // sharedialog閉じた時
    const handleCloseEventShareDialog = () => {
        // list初期化のタイミングは予定ダイアログ閉じた時に変更
        //setShareGroupList([]);
        //setShareContactList([]);
        shareRoomidFilterAndFormat(shareMyroomList, shareGroupList, shareContactList);
        setEventShareDialog(false);
    }

    // sharediarogのlistbutton押された時、対象のissharedを反転
    const handleShareListClick = (type, clickedele) => {
        if (type === "myroom") {
            setShareMyroomList((prevState) =>
                prevState.map((obj) =>
                    obj.roomid === clickedele.roomid
                        ? {
                            ...obj,
                            isshared: clickedele.isshared === "0"
                                ? "1"
                                : "0",
                        }
                        : obj
                )
            );
        }
        if (type==="group") {
            setShareGroupList((prevState) =>
                prevState.map((obj) =>
                    obj.roomid === clickedele.roomid
                        ? {
                            ...obj,
                            isshared: clickedele.isshared === "0"
                                ? "1"
                                : "0",
                        }
                        : obj
                )
            );
        }
        if (type === "contact") {
            setShareContactList((prevState) =>
                prevState.map((obj) =>
                    obj.roomid === clickedele.roomid
                        ? {
                            ...obj,
                            isshared: clickedele.isshared === "0"
                                ? "1"
                                : "0",
                        }
                        : obj
                )
            );
        }
    }

    // 公開対象のroomidを抽出して整形
    const shareRoomidFilterAndFormat = async(argMyroomList ,argGroupList, argContactList) => {
        let filtedMyroomList = argMyroomList.filter(ele => {
            return ele.isshared === "1"
        })
        let filtedGroupList = argGroupList.filter(ele => {
            return ele.isshared === "1"
        })
        let filtedContactList = argContactList.filter(ele => {
            return ele.isshared === "1"
        })

        let issharedList = [...filtedMyroomList, ...filtedGroupList, ...filtedContactList];
        console.log("shareRoomidFilterAndFormat", issharedList)
        // [{roomid:0000},{roomid: 9999}...]のような形にする
        let retRoomidList = [];
        let retRoomnameList = [];
        for (const ele of issharedList) {
            retRoomidList.push({ roomid: ele.roomid })
            retRoomnameList.push({ roomname: ele.roomname })
        }
        await setShareRoomidList(retRoomidList);
        await setShareRoomnameList(retRoomnameList);
    }

    // 繰り返し登録系

    const handleBatchOpen = () => {

        // ◯日おきなどの選択肢の生成
        // 日、週、月、その他
        const tmpD = ["毎日"];
        const tmpW = ["毎週","隔週"];
        const tmpM = ["毎月"];
        const tmpO = ["毎月1日"];


        for (let i = 2; i <= 30; i++) { tmpD.push(`${i}日ごと`); }
        for (let i = 3; i <= 30; i++) { tmpW.push(`${i}週ごと`); }
        for (let i = 2; i <= 30; i++) { tmpM.push(`${i}ヶ月ごと`); }

        // 第n◯曜日
        const startDateDayjs = dayjs(currentSelectionInfo.start).format('dddd');
        for (let i = 1; i <= 4; i++) {
            tmpO.push(`毎月第${i}${startDateDayjs}`);
        }
        tmpO.push(`毎月最終${startDateDayjs}`);
        tmpO.push("毎月最終日");

        const tmpOptions = { d: tmpD, w: tmpW, m: tmpM, o: tmpO }
        setBatchOptions(tmpOptions);

        setBatchOpen(true);
        setSelectedBatchPeriod("d");
    };

    const handleBatchClose = (event,reason) => {
        if (reason === 'backdropClick') return;
        setBatchOpen(false);
        
    };

    // 繰り返しダイアログで「繰り返しなし」が押された時
    // 繰り返し先を全削除し、ダイアログを閉じる
    const handleSelectBatchCancel = () => {
        setSelectedBatchDates([]);
        setBatchChecked([]);
        setBatchLimitDate("");
        handleBatchClose();

    }


    // 繰り返し対象が変更された時、
    //const handleSelectedBatchDatesChange = (date) => {
    //    if (date) {
    //        const index = selectedBatchDates.findIndex(d => d.format('YYYY-MM-DD') === date.format('YYYY-MM-DD'));

    //        if (index === -1) {
    //            // まだ選択されていない日付の場合、追加
    //            setSelectedBatchDates([...selectedBatchDates, date]);
    //        } else {
    //            // すでに選択されている日付の場合、削除
    //            const newDates = [...selectedBatchDates];
    //            newDates.splice(index, 1);
    //            setSelectedBatchDates(newDates);
    //        }
    //    }
    //};

    //繰り返しダイアログ内、日・週・月・その他のボタン処理
    const handleSelectBatchPeriod = (period) => {
        if (period === "d" || period === "w" || period === "m" || period === "o") {
            //setSelectedBatchDates([]);
            setSelectedBatchPeriod(period);
        } else {
            //setSelectedBatchDates([]);
            setSelectedBatchPeriod("d");
        }
    }

    useEffect(() => {
        // dataが変更されたときに実行される処理
        // periodが変わった時、これまでの選択全削除
        setBatchChecked([]);
    }, [selectedBatchPeriod]); 





    
    const handleSelectBatchOption = (value) => () => {
        setBatchChecked([value]);
        computeBatchDates([value], batchLimitDate);
    };

    // 繰り返しのlimit更新時
    const updateBatchLimitDate = (ele) => {
        setBatchLimitDate(dayjs(ele.$d).format("YYYY-MM-DD"));

        // ついでにここで繰り返し対象のstartを特定し、selectedBatchDates に入れておく
        computeBatchDates(batchChecked, dayjs(ele.$d).format("YYYY-MM-DD"));
        

    };

    const computeBatchDates = (argBatchChecked,argBatchLimitDate) => {
        // チェックボックスと期間設定どちらもされているときのみ実行
        if (argBatchChecked[0] && argBatchLimitDate && argBatchLimitDate !== "Invalid Date" ) {
            // 繰り返し期間 
            const batchDateFrom = dayjs(currentSelectionInfo.start);
            const batchDateTo = dayjs(argBatchLimitDate);
            const batchCheckedStr = argBatchChecked[0];
            let batchInterval = 0;
            let tmpBatchDateArr = [];

            let currentDate = batchDateFrom.clone(); // 開始日をコピーしてループ用変数に設定
            let convPeriod = "";

            if (selectedBatchPeriod === "d" || selectedBatchPeriod === "w" || selectedBatchPeriod === "m") {
                //d, w, mの時は、from to の期間内で、batchintervalの間隔でぶん回す
                if (selectedBatchPeriod === "d") {
                    convPeriod = "day"; 
                    if (batchCheckedStr === "毎日") {
                        batchInterval = 1;
                    } else {
                        batchInterval = parseInt(batchCheckedStr.replace("日ごと",""));
                    }
                } else if (selectedBatchPeriod === "w") {
                    convPeriod = "week"; 
                    if (batchCheckedStr === "毎週") {
                        batchInterval = 1;
                    } else if (batchCheckedStr === "隔週") {
                        batchInterval = 2;
                    } else {
                        batchInterval = parseInt(batchCheckedStr.replace("週ごと",""));
                    }
                } else if (selectedBatchPeriod === "m") {
                    convPeriod = "month"; 
                    if (batchCheckedStr === "毎月") {
                        batchInterval = 1;
                    } else {
                        batchInterval = parseInt(batchCheckedStr.replace("ヶ月ごと",""));
                    }
                }
                

                while (currentDate.isSameOrBefore(batchDateTo)) {
                    tmpBatchDateArr.push(currentDate.format('YYYY-MM-DD')); // YYYY-MM-DD形式で日付を配列に追加
                    currentDate = currentDate.add(batchInterval, convPeriod); // 指定された間隔で日付をインクリメント
                }
            }

             // oはそれぞれのケースに合わせて個別対応
            if (selectedBatchPeriod === "o") {
                if (batchCheckedStr === "毎月1日") {
                    // 開始日を月の初日に調整
                    let firstDayOfCurrentMonth = currentDate.startOf('month');
                    if (firstDayOfCurrentMonth.isBefore(batchDateFrom, 'day')) {
                        currentDate = currentDate.add(1, 'month').startOf('month');
                    } else {
                        currentDate = firstDayOfCurrentMonth;
                    }

                    while (currentDate.isSameOrBefore(batchDateTo)) {
                        tmpBatchDateArr.push(currentDate.format('YYYY-MM-DD')); // YYYY-MM-DD形式で配列に追加
                        currentDate = currentDate.add(1, 'month').startOf('month'); // 次の月の初日に進む
                    }

                } else if (batchCheckedStr === "毎月最終日") {
                    // 開始日を月の最終日に調整
                    let lastDayOfCurrentMonth = currentDate.endOf('month').startOf('day');
                    if (lastDayOfCurrentMonth.isBefore(batchDateFrom, 'day')) {
                        currentDate = currentDate.add(1, 'month').endOf('month').startOf('day');
                    } else {
                        currentDate = lastDayOfCurrentMonth;
                    }

                    while (currentDate.isSameOrBefore(batchDateTo)) {
                        tmpBatchDateArr.push(currentDate.format('YYYY-MM-DD')); // YYYY-MM-DD形式で配列に追加
                        currentDate = currentDate.add(1, 'month').endOf('month').startOf('day'); // 次の月の最終日に進む
                    }

                } else {
                    // 曜日縛り

                    // 曜日を数値に変換する関数
                    function getDayOfWeekNumber(day) {
                        const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
                        return daysOfWeek.indexOf(day);
                    }

                    if (batchCheckedStr.includes("最終")) {
                        // 毎月最終◯曜日
                        const match = batchCheckedStr.match(/毎月最終([月火水木金土日])曜日/);
                        let weekDay = "";
                        if (match && match[1]) {
                            weekDay = match[1];
                            const targetDayOfWeek = getDayOfWeekNumber(weekDay);

                            // 開始日を調整
                            let lastTargetDayOfMonth = currentDate.endOf('month').startOf('day');
                            while (lastTargetDayOfMonth.day() !== targetDayOfWeek) {
                                lastTargetDayOfMonth = lastTargetDayOfMonth.subtract(1, 'day');
                            }
                            if (lastTargetDayOfMonth.isBefore(batchDateFrom, 'day')) {
                                currentDate = currentDate.add(1, 'month').endOf('month').startOf('day');
                                while (currentDate.day() !== targetDayOfWeek) {
                                    currentDate = currentDate.subtract(1, 'day');
                                }
                            } else {
                                currentDate = lastTargetDayOfMonth;
                            }
                            while (currentDate.isSameOrBefore(batchDateTo)) {
                                tmpBatchDateArr.push(currentDate.format('YYYY-MM-DD')); // YYYY-MM-DD形式で配列に追加
                                currentDate = currentDate.add(1, 'month').endOf('month').startOf('day');

                                while (currentDate.day() !== targetDayOfWeek) {
                                    currentDate = currentDate.subtract(1, 'day');
                                }
                                
                            }
                        }

                    } else {
                        // 毎月第n◯曜日
                        const match = batchCheckedStr.match(/毎月第(\d+)([月火水木金土日])曜日/);
                        let weekNumber = 0;
                        let weekDay = "";
                        if (match && match[1] && match[2]) {
                            weekNumber = parseInt(match[1], 10);
                            weekDay = match[2];

                            const targetDayOfWeek = getDayOfWeekNumber(weekDay);

                            let currentDate = batchDateFrom.clone().startOf('month'); // 開始月の初日

                            while (currentDate.isSameOrBefore(batchDateTo)) {
                                let batchWeekCount = 0; // 各月でカウントをリセット
                                let foundDate = null;

                                for (let i = 0; i < 31; i++) { // 最大31日まで探索
                                    if (currentDate.day() === targetDayOfWeek) {
                                        batchWeekCount++;
                                        if (batchWeekCount === weekNumber) {
                                            foundDate = currentDate.clone();
                                            break;
                                        }
                                    }
                                    currentDate = currentDate.add(1, 'day');
                                }

                                if (foundDate
                                    && foundDate.isSameOrAfter(batchDateFrom, 'day')
                                    && foundDate.isSameOrBefore(batchDateTo)
                                ) {
                                    tmpBatchDateArr.push(foundDate.format('YYYY-MM-DD'));
                                }
                                currentDate = currentDate.add(1, 'month').startOf('month'); // 次の月の初日
                            }
                        }
                    }
                }
            }

            // 最後に複製元の日付は除去し、上限30件のチェックを入れる
            // 複製元の日付除去
            //tmpBatchDateArr = tmpBatchDateArr.filter(item => dayjs(item) !== batchDateFrom); 

            let filtedBatchDateArray = [];

            for (let i = 0; i < tmpBatchDateArr.length; i++) {
                if (tmpBatchDateArr[i] !== dayjs(currentSelectionInfo.start).format('YYYY-MM-DD')) {
                    filtedBatchDateArray.push(tmpBatchDateArr[i]);
                }
            }
            // 上限30件チェックにあたったらスライス
            if (filtedBatchDateArray.length > 30) {
                filtedBatchDateArray = filtedBatchDateArray.slice(0, 30);
            }
            //console.log("filtedBatchDateArray", filtedBatchDateArray);
            setSelectedBatchDates(filtedBatchDateArray);

        }
        //else {
        //    console.log("空振り", "c", argBatchChecked[0], "l", argBatchLimitDate)
        //}
    }

    const insertBatch = async (newEventid) => {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                originalEventid: newEventid.toString(),
                targetDates: selectedBatchDates
            })
        };
        console.log("insertBatch start")
        await fetch("/batch", requestOptions
        // ).then((response) => console.log("batch post ok", response)
        ).then((response) => response.json()
        ).then((responseJson) => {
            console.log("batch post ok", responseJson);
        }).catch((err) => {
            console.log("batch post ng", err);
        })
    }






    // event post 終了後、返り値の新eventidを使って share post実行
    const upRoomidToShareWithNewEventid = async (newEventid, argShareRoomidList) => {
        // shareRoomidList内容あり && 今のroomidが登録されてない時、今のroomidも追加
        const LSroomid = sessionRef.current.roomid
        let requestroomidlist = []

        // argShareRoomidList:ユーザが参加している部屋のうち、共有先として選択された情報
        // ↑だけで更新すると、自分から見えない部屋（相手のマイルームなど）へ共有されているケースに対応できない。
        // /share get時に、見えない部屋への共有情報を取得、storeに逃がしているので、ここで合流させる。
        let combinedShareRoomidList = [...argShareRoomidList, ...invisibleSharedRoomidList]

        if (combinedShareRoomidList.length > 0) {
            var some = combinedShareRoomidList.some((ele) => ele.roomid === LSroomid.toString())
            if (some === false) {
                requestroomidlist = [...combinedShareRoomidList, { roomid: LSroomid.toString() }]
            }
            else {
                requestroomidlist = combinedShareRoomidList
            }
        } else {
            requestroomidlist = combinedShareRoomidList
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                eventid: newEventid.toString(),
                roomidToShares: requestroomidlist
            })
        };
        console.log("share post deleteinsert start")
        await fetch("/share", requestOptions
        ).then((response) => console.log("share post deleteinsert ok", response)
        ).catch((err) => {
            console.log("share post deleteinsert error", err);
        })
    }

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const handleCloseSearchDialog = () => {
        setSearchDialog(false);
        setSearchedMessage("");
        setSearchedEvents([]);
        setTabIndex(0);
    };

    // 検索用
    const handleSearchFormKeyDown = async(e) => {
        // Enterキーが押された時、検索してフォーカス解除
        if (e.keyCode === 13) {
            console.log(e.target.value);
            e.target.blur();
            // ローディング処理入れる
            const LSroomid = sessionRef.current.roomid
            await fetch(`/search?roomid=${LSroomid}&searchwords=${e.target.value}`,
            ).then((response) => response.json()
            ).then((responseJson) => {
                console.log("search get ok", responseJson);
                handleApplyEvent(responseJson.eventslist, responseJson.notislist, "searchedEvents")
                setSearchedMessage(`検索結果：${responseJson.eventslist.length}件`);
            }).catch((err) => {
                setSearchedEvents([]);
                setSearchedMessage("");
                console.log("search get error", err);
            })
        }
    }

    const FormatSearchedSecondary = (event) => {
        if (event.allDay) {
            if (dayjs(event.end).diff(dayjs(event.start), 'day') > 1) {
                // startと end の日単位差分が1以上の時
                let retallmaltiday =
                    dayjs(event.start).format("MM/DD")
                    + " - "
                    + dayjs(event.end).subtract(1, 'd').format("MM/DD")
                    + " 終日";
                return retallmaltiday;
            } else {
                return "終日";
            }
        } else {
            let retStr = "";
            retStr += dayjs(event.start).format("HH:mm");
            retStr += " - ";
            if (dayjs(event.start).format("YYYY-MM-DD") === dayjs(event.end).format("YYYY-MM-DD")) {
                retStr += dayjs(event.end).format("HH:mm");
            } else {
                retStr += dayjs(event.end).format("MM/DD HH:mm");
            }
            return retStr;
        }
    }

    const searchSubHeaderFunc = (event,index) => {
        if (index === 0) {
            return true;
        } else if (dayjs(event.start).format("YYYY-MM-DD") !== dayjs(searchedEvents[index - 1].start).format("YYYY-MM-DD")) {
            return true;
        } else {
            return false;
        }
    }

    const getHolidays = async() => {
        await fetch(`https://holidays-jp.github.io/api/v1/date.json`)
            .then((response) => response.json())
            .then((responseJson) => {
                console.log("res get ok", responseJson);
                // 今年＋前後一年、3年分の祝日が reponseJson に取得される
                // {2024-01-01: '元日', 2024-01-08: '成人の日', 2024-02-11: '建国記念の日', ...}
                setHoliday(responseJson);

            })
            .catch((err) => {
                console.log("get error", err);
        })
    }

    const renderDayCellContent = (dateInfo) => {
        const dateStr = dayjs(dateInfo.date).format("YYYY-MM-DD"); // YYYY-MM-DD形式の文字列を取得
        const holidayName = holiday[dateStr];
        const colorRed = isDarkMode ? '#ff8a80' : 'red';   // ダークモード時は薄い赤（パステルレッド）
        const colorBlue = isDarkMode ? '#8c9eff' : 'blue'; // ダークモード時は薄い青（パステルブルー）

        if (holidayName) {
            // 祝日の時、色変更＋祝日名表示
            return (
                <>
                    <div style={{ textAlign: 'right', color: colorRed }}>
                        {dateInfo.dayNumberText.replace("日", "")}
                    </div>
                    <div style={{ textAlign: 'right', fontSize: isSpDevice ? '8px' : '10px', color: colorRed }}>
                        {holidayName}
                    </div>
                </>
            );
        } else {
            if (dayjs(dateInfo.date).day() === 0) {
                // 日曜の時、色変更
                return (
                    <>
                        <div style={{ textAlign: 'right', color: colorRed }}>
                            {dateInfo.dayNumberText.replace("日", "")}
                        </div>
                    </>
                );

            } else if (dayjs(dateInfo.date).day() === 6) {
                // 土曜の時、色変更
                return (
                    <>
                        <div style={{ textAlign: 'right', color: colorBlue }}>
                            {dateInfo.dayNumberText.replace("日", "")}
                        </div>
                    </>
                );

            } else {
                // ノーマル
                return (
                    <>
                        {dateInfo.dayNumberText.replace("日", "")}
                    </>
                );
            }
        }
    };

    const renderEventContent = (eventInfo) => {
        const { event, view } = eventInfo;
        const { title, extendedProps, allDay, backgroundColor, start } = event;



        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: isSpDevice ? '1px' : '2px',
                overflow: 'hidden',
                fontSize: isSpDevice ? '10px' : '12px',
                height: isSpDevice ? '15px' : '18px',
                borderLeft: !allDay && `4px solid ${backgroundColor}`
            }}>
                {!allDay && (
                    <Box sx={{ mr:0.5, fontSize: isSpDevice?"8px":"10px"}}>
                        {dayjs(start).format("H:mm") }
                    </Box>
                )}
                {extendedProps.addText && (
                    <SubjectIcon fontSize='inherit' />
                )}
                <div
                    style={{
                        whiteSpace: 'nowrap', // テキストを折り返さない
                        overflow: 'hidden',
                        textOverflow: isSpDevice ? '' : 'ellipsis',
                        maxWidth: '100%',

                    }}
                >
                    {title}
                </div>
                
            </div>
        );
    };






    // ローカルでの仮処理用 とりあえず連番ID持ってもらう
    function createEventId() {
        setEventGuid(eventGuid + 1);
        return String(eventGuid);
    }


    // 認証失敗 or param不正の場合、簡素なエラー画面を表示
    if (errorDialog[0]) {
        return (
            <div>error {errorDialog[1]}</div>
        )
    }
    
    return (
        <ThemeProvider theme={theme}>
            {/*{isSpDevice ? "モバイルだよ" : "モバイルじゃないよ"}*/}
                {/*初回ロード時のくるくる*/}
                {/*<Backdrop*/}
                {/*sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}*/}
                {/*open={circularProgressIsActive}*/}
                {/*>*/}
                {/*    <CircularProgress color="inherit" />    */}
                {/*</Backdrop>*/}
                <CssBaseline />

                {isDarkMode && (
                    <style>
                        {`
                        .fc {
                            --fc-page-bg-color: #121212;
                            --fc-neutral-bg-color: #1e1e1e;
                            --fc-neutral-text-color: #ffffff;
                            --fc-border-color: #444444;
                            --fc-button-text-color: #ffffff;
                            --fc-button-bg-color: #333333;
                            --fc-button-border-color: #444444;
                            --fc-button-hover-bg-color: #444444;
                            --fc-button-hover-border-color: #555555;
                            --fc-button-active-bg-color: #555555;
                            --fc-button-active-border-color: #666666;
                            --fc-today-bg-color: rgba(255, 255, 255, 0.1);
                        }
                        .fc .fc-col-header-cell-cushion, 
                        .fc .fc-daygrid-day-number {
                            color: #e0e0e0;
                        }
                    `}
                    </style>
                )}

                <div>

                {/*初回ロード時のくるくる ver2*/}
                <Backdrop
                    sx={{ color: '#ffffff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={circularProgressIsActive}
                >
                    <div className="sk-cube-grid">
                        <div className="sk-cube sk-cube1"></div>
                        <div className="sk-cube sk-cube2"></div>
                        <div className="sk-cube sk-cube3"></div>
                        <div className="sk-cube sk-cube4"></div>
                        <div className="sk-cube sk-cube5"></div>
                        <div className="sk-cube sk-cube6"></div>
                        <div className="sk-cube sk-cube7"></div>
                        <div className="sk-cube sk-cube8"></div>
                        <div className="sk-cube sk-cube9"></div>
                    </div>
                </Backdrop>


                {/*ロード時のLinearProgress*/}
                {linearProgressIsActive && (<LinearProgress />)}
                {!linearProgressIsActive && (<Box sx={{ height: 4 }} />)}
                <div {...handlers} style={{ userSelect: "none" }}>
                    {/*このdiv内でswip検知*/}
                    <FullCalendar
                        fixedWeekCount={false}
                        // showNonCurrentDates={false}
                        firstDay={0}
                        height="90vh"
                        //aspectRatio={1.8}
                        headerToolbar={
                            isSpDevice ?
                                {
                                    start: "title",
                                    center: "",
                                    end: "customSearch listMonth,dayGridMonth",
                                } : {
                                    start: "prev,next",
                                    center: "title",
                                    end: "customSearch listMonth,dayGridMonth",
                                }
                        }
                        // 自作のヘッダーボタン設定
                        customButtons={{
                            customSearch: {
                                text: '検索',
                                click: function () {
                                    setTabIndex(0); 
                                    setSearchDialog(true);
                                }
                            }
                        }}

                        buttonText={buttonTexts}
                        dayCellContent={(e) =>
                            (e.dayNumberText = e.dayNumberText.replace("日", ""))
                        } // 「〇日」の「日」を表示させない
                        datesSet={handleDateChange}
                        plugins={[dayGridPlugin, interactionPlugin, listPlugin]}
                        initialView={"dayGridMonth"}
                        locales={[jaLocale]}
                        locale="ja"
                        // events={"https://fullcalendar.io/api/demo-feeds/events.json"}
                        events={events}
                        eventOrder={"start"}

                        dateClick={isSpDevice && handleDateSelect}
                        editable={isSpDevice ? false : true}
                        selectable={isSpDevice ? false : true} // スマホの時は複数選択無効
                        select={isSpDevice ? handleDateUnselect : handleDateSelect}
                        droppable={isSpDevice ? false : true} // スマホの時はイベントのドラッグ移動無効
                        ref={calendarRef}
                        eventClick={handleEventClick}
                        eventDrop={!isSpDevice && handleEventDrop}
                        eventResize={!isSpDevice && handleEventResize}
                        businessHours={true}
                        dayCellContent={renderDayCellContent}
                        eventContent={renderEventContent}


                        // selectLongPressDelay={0} // スマホでタップした時速反応
                        // ↑スマホの時はselectではなくdateClickを使うようにしたので不要
                    />
                </div>
                {/* 予定追加ダイアログ */}
                {/*{theme.breakpoints.down('xs')?"モバイルだよ":"モバイルじゃないよ"}*/}
                <Dialog
                    open={addEventDialog}
                    onClose={handleDateUnselect}
                    fullScreen={isSpDevice?true:false }
                    sx={isSpDevice ? {}:{ marginLeft: "auto", marginRight: "auto", width: 500,  }}
                    fullWidth
                >
                    <DialogTitle sx={{ pa: 1 }}>
                        {isSpDevice ? (
                            //スマホの時
                            <Grid container sx={{px:1, my:1} }>
                                <Grid item xs="auto">
                                    <Button color="info" onClick={handleDateUnselect}>
                                    {/*<Button color="info" size="small" onClick={() => console.log("calcel clicked")}>*/}
                                        {currentIsAnotherEvent ? (<>戻る</>) : (<>キャンセル</>)}
                                    </Button>
                                </Grid>
                                <Grid item xs></Grid>
                                {(!currentIsAnotherEvent || currentCanAllBeEdited) && (
                                    <Grid item xs="auto">
                                        <Button
                                            variant="outlined"
                                            color="info"
                                            onClick={isEdit ? handleEditEvent : handleAddEvent}
                                        >
                                            {isEdit ? "更新" : "追加"}
                                        </Button>
                                    </Grid>
                                    )
                                }
                            </Grid>
                        ) : (
                            //スマホじゃない時
                                <Grid container>
                                    <Grid item xs></Grid>
                                    <Grid item xs="auto">
                                        <IconButton
                                            color="BGgrey500"
                                            size="small"
                                            // onClick={() => console.log("piyopiyo")}
                                            onClick={handleDateUnselect}
                                            sx={{mr:0.5} }
                                        >
                                            <ClearIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                        ) 
                    }

                    </DialogTitle>
                    <Divider />
                    <DialogContent sx={{ pt:1, pb:2 }}>
                        <Grid container>
                            <Grid item xs={1.5}></Grid>
                            <Grid item xs mb={2}>
                            <TextField
                                    autoFocus={isEdit?false:true }
                                    margin="dense"
                                    id="addEventName"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    placeholder="タイトルを追加"
                                    defaultValue={currentSelectionInfo.title}
                                    // onChange={(event) => setEventTitle(event.target.value)}
                                    onBlur={(event) =>
                                        setCurrentSelectionInfo((prevInfo) => ({
                                            ...prevInfo,
                                            title: event.target.value,
                                        }))
                                    }
                                    style={{ cursor: "pointer" }}
                                    autoComplete="off" //履歴鬱陶しいのでオートコンプリートをオフに
                                    inputProps={{ readOnly: currentIsAnotherEvent && !currentCanAllBeEdited ?true:false }}
                                />
                            </Grid>
                            <Grid item xs={1}></Grid>
                        </Grid>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={1.5}>
                                <AccessTimeIcon fontSize="small" />
                            </Grid>
                            <Grid item xs>
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                    adapterLocale="ja"
                                    dateFormats={{ monthAndYear: "YYYY年M月" }} //カレンダー左上の日付表示
                                    localeText={{
                                        previousMonth: "前月を表示", // < のツールチップ
                                        nextMonth: "次月を表示", // > のツールチップ
                                    }}
                                    sx={{
                                        "& ::-webkit-scrollbar": {
                                            display: "none",
                                        },
                                        // "& :hover": {
                                        //   "::-webkit-scrollbar": {
                                        //     display: "inline",
                                        //   },
                                        // },
                                    }}
                                >
                                    <Stack spacing={1}>
                                        <Grid container alignItems="center" justify="center">
                                            <Grid item xs="auto" sx={{
                                                marginRight: 1,
                                                }}>
                                                開始
                                            </Grid>
                                            <Grid item xs>
                                                {/*編集可能な予定&&全日の時*/}
                                                {(!currentIsAnotherEvent || currentCanAllBeEdited) && currentSelectionInfo.allDay && (
                                                    <ButtonDatePicker
                                                        label={`${!currentSelectionInfo.start
                                                                ? "　"
                                                                : dayjs(currentSelectionInfo.start).format(
                                                                    "MM月DD日"
                                                                )
                                                            }`}
                                                        value={dayjs(currentSelectionInfo.start)}
                                                        onChange={(event) =>
                                                            updateCurrentSelectionInfo("start", event)
                                                        }
                                                    />
                                                )}
                                                {/*編集可能な予定&&時間指定の時*/}
                                                {(!currentIsAnotherEvent || currentCanAllBeEdited) && !currentSelectionInfo.allDay && (
                                                    <ButtonDateTimePicker
                                                        label={`${!currentSelectionInfo.start
                                                                ? "　"
                                                                : dayjs(currentSelectionInfo.start).format(
                                                                    "MM月DD日 HH:mm"
                                                                )
                                                            }`}
                                                        value={dayjs(currentSelectionInfo.start)}
                                                        onChange={(event) =>
                                                            updateCurrentSelectionInfo("start", event)
                                                        }
                                                    />
                                                )}
                                                {/*編集不可の予定&&全日の時*/}
                                                {currentIsAnotherEvent && !currentCanAllBeEdited && currentSelectionInfo.allDay && (
                                                    <Button
                                                        label={`${!currentSelectionInfo.start
                                                            ? "　"
                                                            : dayjs(currentSelectionInfo.start).format(
                                                                "MM月DD日"
                                                            )
                                                            }`}
                                                        variant="outlined"
                                                        sx={{ py: 0.25 }}
                                                    >
                                                        {`${!currentSelectionInfo.start
                                                            ? "　"
                                                            : dayjs(currentSelectionInfo.start).format(
                                                                "MM月DD日"
                                                            )
                                                            }`}
                                                    </Button>
                                                )}
                                                {/*編集不可の予定&&時間指定の時*/}
                                                {currentIsAnotherEvent && !currentCanAllBeEdited && !currentSelectionInfo.allDay && (
                                                    <Button
                                                        label={`${!currentSelectionInfo.start
                                                            ? "　"
                                                            : dayjs(currentSelectionInfo.start).format(
                                                                "MM月DD日 HH:mm"
                                                            )
                                                            }`}
                                                        variant="outlined"
                                                        sx={{ py: 0.25 }}
                                                    >
                                                        {`${!currentSelectionInfo.start
                                                            ? "　"
                                                            : dayjs(currentSelectionInfo.start).format(
                                                                "MM月DD日 HH:mm"
                                                            )
                                                            }`}
                                                    </Button>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Stack>
                                    <Stack spacing={1}>
                                        <Grid container alignItems="center" justify="center" sx={{mt:0.75}}>
                                            <Grid item xs="auto" sx={{
                                                marginRight: 1,
                                            }} >
                                                終了
                                            </Grid>
                                            <Grid item xs>
                                                <LocalizationProvider
                                                    dateAdapter={AdapterDayjs}
                                                    adapterLocale="ja"
                                                    dateFormats={{ monthAndYear: "YYYY年 MM月" }} //カレンダー左上の日付表示
                                                    localeText={{
                                                        previousMonth: "前月を表示", // < のツールチップ
                                                        nextMonth: "次月を表示", // > のツールチップ
                                                    }}
                                                    sx={{
                                                        "& ::-webkit-scrollbar": {
                                                            display: "none",
                                                        },
                                                        // "& :hover": {
                                                        //   "::-webkit-scrollbar": {
                                                        //     display: "inline",
                                                        //   },
                                                        // },
                                                    }}
                                                >
                                                    {(!currentIsAnotherEvent || currentCanAllBeEdited) && currentSelectionInfo.allDay && (
                                                        <ButtonDatePicker
                                                            label={`${!currentSelectionInfo.end
                                                                    ? "　"
                                                                    : dayjs(currentSelectionInfo.end).format(
                                                                        "MM月DD日"
                                                                    )
                                                                }`}
                                                            value={dayjs(currentSelectionInfo.end)}
                                                            onChange={(event) =>
                                                                updateCurrentSelectionInfo("end", event)
                                                            }
                                                            // endのみminDate指定
                                                            minDate={dayjs(currentSelectionInfo.start)}
                                                        />
                                                    )}
                                                    {(!currentIsAnotherEvent || currentCanAllBeEdited) && !currentSelectionInfo.allDay && (
                                                        <ButtonDateTimePicker
                                                            label={`${!currentSelectionInfo.end
                                                                    ? "　"
                                                                    : dayjs(currentSelectionInfo.end).format(
                                                                        "MM月DD日 HH:mm"
                                                                    )
                                                                }`}
                                                            value={dayjs(currentSelectionInfo.end)}
                                                            onChange={(event) =>
                                                                updateCurrentSelectionInfo("end", event)
                                                            }
                                                            // endのみminDate指定
                                                            minDateTime={dayjs(currentSelectionInfo.start)}
                                                        />
                                                    )}
                                                    {/*編集不可の予定&&全日の時*/}
                                                    {currentIsAnotherEvent && !currentCanAllBeEdited && currentSelectionInfo.allDay && (
                                                        <Button
                                                            label={`${!currentSelectionInfo.end
                                                                ? "　"
                                                                : dayjs(currentSelectionInfo.end).format(
                                                                    "MM月DD日"
                                                                )
                                                                }`}
                                                            variant="outlined"
                                                            sx={{ py: 0.25 }}
                                                        >
                                                            {`${!currentSelectionInfo.end
                                                                ? "　"
                                                                : dayjs(currentSelectionInfo.end).format(
                                                                    "MM月DD日"
                                                                )
                                                                }`}
                                                        </Button>
                                                    )}
                                                    {/*編集不可の予定&&時間指定の時*/}
                                                    {currentIsAnotherEvent && !currentCanAllBeEdited && !currentSelectionInfo.allDay && (
                                                        <Button
                                                            label={`${!currentSelectionInfo.end
                                                                ? "　"
                                                                : dayjs(currentSelectionInfo.end).format(
                                                                    "MM月DD日 HH:mm"
                                                                )
                                                                }`}
                                                            variant="outlined"
                                                            sx={{ py: 0.25 }}
                                                        >
                                                            {`${!currentSelectionInfo.end
                                                                ? "　"
                                                                : dayjs(currentSelectionInfo.end).format(
                                                                    "MM月DD日 HH:mm"
                                                                )
                                                                }`}
                                                        </Button>
                                                    )}
                                                </LocalizationProvider>
                                            </Grid>
                                        </Grid>
                                    </Stack>
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        {/* チェックボックス */}
                        <Grid container>
                            <Grid item xs={1.5}></Grid>
                            {/* <Grid item xs={1}></Grid> */}
                            <Grid item xs>
                                <FormGroup>
                                    <FormControlLabel
                                        label={<Typography> 時間指定 </Typography>}
                                        control={currentIsAnotherEvent && !currentCanAllBeEdited ?
                                            <Checkbox
                                                checked={!currentSelectionInfo.allDay}
                                                // onChange={handleCurrentAllDay}
                                                disabled
                                            />
                                            : <Checkbox
                                                checked={!currentSelectionInfo.allDay}
                                                onChange={handleCurrentAllDay}
                                            />
                                        }
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center" justify="center">
                            <Grid item xs={1.5}>
                                <EditNoteIcon fontSize="small" />
                            </Grid>
                            <Grid item xs>
                                <TextField
                                    id="eventAddText"
                                    type="text"
                                    multiline
                                    fullWidth
                                    variant="standard"
                                    placeholder="説明・URLを追加"
                                    defaultValue={currentAddText}
                                    onBlur={(e) => setCurrentAddText(e.target.value)}
                                    autoComplete="off" //履歴鬱陶しいのでオートコンプリートをオフに
                                    inputProps={{ readOnly: currentIsAnotherEvent && !currentCanAllBeEdited ? true : false }}
                                />
                            </Grid>
                            <Grid item xs={1}></Grid>
                        </Grid>
                        <Grid container alignItems="center" justify="center" sx={{ mt:"12px"}}>
                            <Grid item xs={1.5}>
                                <NotificationsActiveOutlinedIcon fontSize="small" />
                            </Grid>
                            <Grid item xs>
                                <Stack
                                    direction="column"
                                    justifyContent="flex-start"
                                    alignItems="flex-start"
                                >
                                    {currentEventNotification.length > 0 &&
                                        (!currentIsAnotherEvent || currentCanAllBeEdited) &&
                                        currentEventNotification.map((notificationObj, index) => (
                                            <Grid
                                                container
                                                key={`notiDatetimepicker${notificationObj.time}${index}`}
                                            >
                                                <Grid item xs="auto">
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterDayjs}
                                                        adapterLocale="ja"
                                                        dateFormats={{ monthAndYear: "YYYY年 MM月" }} //カレンダー左上の日付表示
                                                        localeText={{
                                                            previousMonth: "前月を表示", // < のツールチップ
                                                            nextMonth: "次月を表示", // > のツールチップ
                                                        }}
                                                    >
                                                        <NotificationDateTimePicker
                                                            label={`${!notificationObj.time
                                                                    ? "　"
                                                                    : dayjs(notificationObj.time).format(
                                                                        "MM月DD日 HH:mm"
                                                                    )
                                                                }`}
                                                            value={dayjs(notificationObj.time)}
                                                            onAccept={(selectedDate) =>
                                                                handleUpdateNotification(selectedDate, index)
                                                            }
                                                            openTo={"hours"}
                                                        />
                                                    </LocalizationProvider>
                                                </Grid>
                                                <Grid item xs="auto">
                                                    {/* 通知削除の✕ */}
                                                    <IconButton
                                                        color="BGgrey500"
                                                        size="small"
                                                        // onClick={() => console.log("piyopiyo")}
                                                        onClick={() => handleDeleteNotification(index)}
                                                    >
                                                        <ClearIcon />
                                                    </IconButton>
                                                </Grid>
                                                <Grid item xs></Grid>
                                            </Grid>
                                        ))}
                                    {/*編集不可の予定*/}
                                    {currentEventNotification.length > 0 && currentIsAnotherEvent && !currentCanAllBeEdited &&
                                        currentEventNotification.map((notificationObj, index) => (
                                            <Grid
                                                container
                                                key={`notiDatetimepicker${notificationObj.time}${index}`}
                                            >
                                                <Grid item xs="auto">
                                                    <Button
                                                        label={`${!notificationObj.time
                                                            ? "　"
                                                            : dayjs(notificationObj.time).format(
                                                                "MM月DD日 HH:mm"
                                                            )}`}
                                                        color="inherit"
                                                        size="small"
                                                    >
                                                        {`${!notificationObj.time
                                                            ? "　"
                                                            : dayjs(notificationObj.time).format(
                                                                "MM月DD日 HH:mm"
                                                            )}`}
                                                    </Button>
                                                </Grid>
                                                <Grid item xs></Grid>
                                            </Grid>
                                        ))}
                                    {currentEventNotification.length === 0 && currentIsAnotherEvent && !currentCanAllBeEdited && (
                                        <Button
                                            size="small"
                                            color="inherit"
                                            sx={{ px: 0 }}
                                        >
                                            グループ通知設定なし
                                        </Button>
                                    )}
                                    {/* なんやかんやしてeventsに放り込むようにする */}
                                    {/* {currentEventNotification.length} */}
                                </Stack>
                                {(!currentIsAnotherEvent || currentCanAllBeEdited) && (
                                    <Button
                                        size="small"
                                        color="inherit"
                                        onClick={handleAddNotification}
                                        sx={{px:0} }
                                    >
                                        グループ通知を追加
                                    </Button>
                                )}

                            </Grid>
                        </Grid>
                        {(!currentIsAnotherEvent || currentCanAllBeEdited) && (
                            <Grid container alignItems="center" justify="center" sx={{ mt: "2px" }}>
                                <Grid item xs={1.5}>
                                    <LinkIcon fontSize="small" />
                                </Grid>
                                <Grid item xs="auto">
                                    <Button
                                        size="small"
                                        color="inherit"
                                        onClick={handleOpenEventShareDialog}
                                        sx={{ px: 0 }}
                                    >
                                        公開先の追加・変更
                                    </Button>
                                </Grid>
                                <Grid item xs="auto">
                                    <Typography variant="caption" display="block" >
                                        {shareRoomidList.length > 0 && (
                                            <>（{shareRoomidList.length }件）</>
                                        )}
                                    </Typography>
                                </Grid>
                                <Grid item xs></Grid>
                            </Grid>
                        )}
                        {currentSelectionInfo.name && (
                            <Grid container alignItems="center" justify="center" sx={{ mt: "2px" }}>
                                <Grid item xs={1.5}>
                                    <EventNoteOutlinedIcon fontSize="small" />
                                </Grid>
                                <Grid item xs="auto" sx={{ fontSize: 13 }}>
                                    {currentCanAllBeEdited
                                        ? (<>最終更新者：{currentSelectionInfo.name}</>)
                                        : (<>作成者：{currentSelectionInfo.name}</>)}
                                </Grid>
                                <Grid item xs></Grid>
                            </Grid>
                        )}
                        <Grid container alignItems="center" sx={{ mt: "2px" }}>
                            <Grid item xs={1.5}>
                                <AssignmentIndOutlinedIcon fontSize="small" />
                            </Grid>
                            <Grid item xs>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {currentAssignees.map((person) => (
                                        <Chip
                                            key={person.honbuid}
                                            label={person.name}
                                            onDelete={() => {
                                                // 削除ロジック
                                                setCurrentAssignees(prev => prev.filter(a => a.honbuid !== person.honbuid));
                                            }}
                                            size="small"
                                        />
                                    ))}
                                    <Button
                                        startIcon={<AddCircleOutlineIcon />}
                                        onClick={() => setAssigneeDialogOpen(true)}
                                        size="small"
                                        color="inherit"
                                        sx={{
                                            fontSize: "12px",
                                            color: "text.secondary",
                                            padding: "2px"
                                        }}
                                    >
                                        担当者を追加
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                        {/*繰り返し登録*/}
                        {(!currentIsAnotherEvent || currentCanAllBeEdited) && (
                            <Grid container alignItems="center" justify="center" sx={{ mt: "2px" }}>
                                <Grid item xs={1.5}>
                                    <ContentCopyIcon fontSize="small" />
                                </Grid>
                                <Grid item xs="auto">
                                    <Button
                                        size="small"
                                        color="inherit"
                                        onClick={handleBatchOpen}
                                        sx={{ px: 0 }}
                                    >
                                        予定の複製
                                    </Button>                                    
                                </Grid>
                                <Grid item xs></Grid>
                            </Grid>
                        )}
                        {(!currentIsAnotherEvent || currentCanAllBeEdited) && (
                            <Grid container alignItems="center" justify="center" sx={{ mt: "4px" }}>
                                <Grid item xs={1.5}>
                                    <ColorLensIcon fontSize="small" />
                                </Grid>
                                <Grid item xs="auto">
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="BGgrey"
                                        onClick={handleEventColorMenuOpen}
                                        // ボタンのHTML要素取得
                                        ref={anchorEl}
                                        endIcon={<ArrowDropDownIcon />}
                                        sx={{py:"2px", px:"0px"} }
                                    >
                                        <Brightness1Icon
                                            color={currentEventColorObj.name}
                                            fontSize="small"
                                        />
                                    </Button>
                                    {/* https://zenn.dev/koharu2739/articles/353d06dfb91aae */}
                                    {/* ↑を参考にmenuの画面構成作る */}
                                    <Menu
                                        anchorEl={anchorEl.current}
                                        open={eventColorMenuOpen}
                                        onClose={handleEventColorMenuClose}
                                        // 紐づけたHTML要素のどこを標準位置にしてメニューを配置するか設定できる
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "right",
                                        }}
                                        // メニューの起点を設定できる。アニメーションもこの起点から生えるように出現する
                                        transformOrigin={{
                                            vertical: "top",
                                            horizontal: "right",
                                        }}
                                    >
                                        <Card sx={{ minWidth: 275 }}>
                                            <CardContent>
                                                <Stack direction="row">
                                                    {/* ここにカラパレ突っ込む */}
                                                    {eventColorMember.map((eventcolor) => (
                                                        <IconButton
                                                            key={`eventcolorselectkey${eventcolor.name}`}
                                                            aria-label={`eventcolorselect${eventcolor.name}`}
                                                            color={eventcolor.name}
                                                            size="small"
                                                            sx={{ p: 0 }}
                                                            onClick={() =>
                                                                handleEventColorIsChanged(eventcolor)
                                                            }
                                                        >
                                                            <Brightness1Icon />
                                                        </IconButton>
                                                    ))}
                                                </Stack>
                                            </CardContent>
                                            <CardActions>
                                                <Button size="small" onClick={handleEventColorMenuClose}>
                                                    戻る
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </Menu>
                                </Grid>
                                <Grid item xs></Grid>
                            </Grid>
                        )}
                        {/*作成者が自分&&編集許可してない時のみ出現*/}
                        {(!currentIsAnotherEvent && !currentCanAllBeEdited) && (
                            <Grid container alignItems="center" justify="center" sx={{ mt: "4px" }}>
                                <Grid item xs={1.5}><PeopleOutlineIcon fontSize="small" /></Grid>
                                {/* <Grid item xs={1}></Grid> */}
                                <Grid item xs>
                                    <FormGroup>
                                        <FormControlLabel
                                            label={<Typography variant="caption"> 他メンバーの編集・削除を許可 </Typography>}
                                            control={
                                                <Checkbox
                                                    checked={tmpCurrentAllBeEdited}
                                                    onChange={handleChangeCanAllBeEdited}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Grid>
                            </Grid>
                        )}

                        
                        
                        {isSpDevice && isEdit && (!currentIsAnotherEvent || currentCanAllBeEdited) &&(
                            //スマホの削除ボタン
                            <Grid container sx={{mt:"30px"} }>
                                <Grid item xs></Grid>
                                <Grid item xs="auto">
                                    {/*<Button onClick={handleDeleteEvent} style={{ cursor: "pointer" }}>*/}
                                    <Button onClick={()=>setConfirmToDelete(true)} style={{ cursor: "pointer" }}>
                                        <p style={{ color: "red", margin: 0 }}>この予定を削除</p>
                                    </Button>
                                </Grid>
                                <Grid item xs></Grid>
                            </Grid>
                        )}
                        {isSpDevice && isEdit && currentIsAnotherEvent && !currentCanAllBeEdited && (
                            //他人の予定なので編集不可
                            <Grid container sx={{ mt: "30px" }} alignItems="center" justify="center">
                                <Grid item sx={{mr:"4px"} }><InfoOutlinedIcon size="small" /></Grid>
                                <Grid item>
                                    <Typography variant="caption" display="block" >
                                        予定の作成者ではないため、編集・削除は出来ません。
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}


                    </DialogContent>
                    {!isSpDevice && (<Divider />) }
                    {!isSpDevice && (!currentIsAnotherEvent || currentCanAllBeEdited) && (
                        <DialogActions>
                            {isEdit && (
                                //<Button onClick={handleDeleteEvent} style={{ cursor: "pointer" }}>
                                <Button onClick={()=>setConfirmToDelete(true)} style={{ cursor: "pointer" }}>
                                    <p style={{ color: "red", margin:0 }}>削除</p>
                                </Button>
                            )}
                            <div style={{ flex: "1 0 0" }} />
                            {/*<Button onClick={handleDateUnselect} style={{ cursor: "pointer" }}>*/}
                            {/*    取り消し*/}
                            {/*</Button>*/}
                            <Button
                                variant="contained"
                                color="info"
                                onClick={isEdit ? handleEditEvent : handleAddEvent}
                                sx={{ py:"3px" }}
                            >
                                {isEdit ? "更新" : "追加"}
                            </Button>
                        </DialogActions>
                    )}
                    {!isSpDevice && currentIsAnotherEvent && !currentCanAllBeEdited && (
                        <DialogActions>
                            <Grid container alignItems="center" justify="center" sx={{px:isSpDevice?0:2 }}>
                                <Grid item xs={1}><InfoOutlinedIcon /></Grid>
                                <Grid item xs="auto">
                                    <Typography variant="caption" display="block" gutterBottom >
                                        この予定の作成者ではないため、編集・削除は出来ません。
                                    </Typography>
                                </Grid>
                                <Grid item xs></Grid>
                            </Grid>
                        </DialogActions>
                    )}
                </Dialog>
                <Dialog open={confirmToDelete} onClose={() => setConfirmToDelete(false)}>
                    <DialogContent sx={{pt:"20px"}}>この予定を削除します。</DialogContent>
                    <DialogActions>
                        <Grid container sx={{pa:0}}>
                            <Grid item xs="auto">
                                <Button onClick={()=>setConfirmToDelete(false)} style={{ cursor: "pointer" }}>
                                    戻る
                                </Button>
                            </Grid>
                            <Grid item xs></Grid>
                            <Grid item xs="auto">
                                <Button　color="error" onClick={()=>handleDeleteEvent()} style={{ cursor: "pointer" }}>
                                    削除
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={eventShareDialog}
                    onClose={handleCloseEventShareDialog}
                    fullScreen={isSpDevice ? true : false}
                    sx={isSpDevice ? {} : { marginLeft: "auto", marginRight: "auto", width: 400, marginTop: "auto", marginBottom: "auto", height:550 }}
                    fullWidth
                >
                    <DialogTitle>
                        <Grid container sx={{ pl:2, pr: 1, my: 1 }}>
                            <Grid item xs="auto" sx={{ mt: "auto", mb: "auto" }}>
                                <Typography variant="subtitle2" >
                                    予定の公開先を選択
                                </Typography>
                            </Grid>
                            <Grid item xs></Grid>
                            <Grid item xs="auto">
                                <Button
                                    onClick={handleCloseEventShareDialog}
                                >
                                    変更して戻る
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <Divider />
                    
                        {/*share〇〇list取得中はローディング噛ませる*/}
                    {shareListLoading ?
                        (
                            <DialogContent sx={{ height: 438, mt: "10px" }}>
                                グループ
                                <Divider />
                                <Grid container>
                                    <Grid item xs={0.5}></Grid>
                                    <Grid item xs>
                                        <div style={{ height: 64, py: "5px" }}>
                                            <Skeleton height={54} variant="rectangular" animation="wave" />
                                        </div>
                                        <Divider />
                                        <div style={{ height: 64, py: "5px" }}>
                                            <Skeleton height={54} variant="rectangular" animation="wave" />
                                        </div>
                                        <Divider />
                                        <div style={{ height: 64, py: "5px" }}>
                                            <Skeleton height={54} variant="rectangular" animation="wave" />
                                        </div>
                                        <Divider />
                                        <div style={{ height: 64, py: "5px" }}>
                                            <Skeleton height={54} variant="rectangular" animation="wave" />
                                        </div>
                                        <Divider />
                                        <div style={{ height: 64, py: "5px" }}>
                                            <Skeleton height={54} variant="rectangular" animation="wave" />
                                        </div>
                                        <Divider />
                                        <div style={{ height: 64, py: "5px" }}>
                                            <Skeleton height={54} variant="rectangular" animation="wave" />
                                        </div>
                                        <Divider />
                                        <div style={{ height: 64, py: "5px" }}>
                                            <Skeleton height={54} variant="rectangular" animation="wave" />
                                        </div>
                                        <Divider />
                                    </Grid>
                                    <Grid item xs={0.5}></Grid>
                                </Grid>
                            </DialogContent>
                        ) : (
                            <DialogContent sx={{ pt: "10px" }} >
                                {/*{shareRoomnameList.length > 0 && (*/}
                                    
                                {/*        <Grid container>*/}
                                {/*            <Grid item xs="auto">選択中：</Grid>*/}

                                {/*            {shareRoomnameList.map((ele) => */}
                                {/*                <Grid item xs="auto" key={`shareele${ele.roomname}` } >{ele.roomname }</Grid>*/}
                                {/*            )}*/}
                                {/*            <Grid item xs="auto"></Grid>*/}
                                {/*        </Grid>*/}
                                {/*)}*/}
                                {shareMyroomList.length > 0 && (
                                    <React.Fragment>
                                        個人
                                        <Divider />
                                        <Grid container sx={{ mb: "10px" }}>
                                            <Grid item xs={0.5}></Grid>
                                            <Grid item xs>
                                                <List sx={{ width: '100%' }}>
                                                    {shareMyroomList.map((ele) =>
                                                        <React.Fragment key={`myele${ele.roomid}`}>
                                                            <ListItem
                                                                secondaryAction={
                                                                    <Checkbox
                                                                        edge="end"
                                                                        onChange={() => handleShareListClick("myroom", ele)}
                                                                        checked={ele.isshared === "1" ? true : false}
                                                                    />
                                                                }
                                                                alignItems="flex-start"
                                                            >

                                                                <ListItemAvatar sx={{ mt: "auto", mb: "auto" }}>
                                                                    <Avatar
                                                                        src={`https://chat-tis.com/Static/downloadAvatar?honbuid=999998&size=small`}
                                                                        sx={{ width: 24, height: 24 }}
                                                                    />
                                                                </ListItemAvatar>
                                                                <ListItemText
                                                                    disableTypography={true}
                                                                    primary={"個人カレンダー"}
                                                                    sx={{ fontSize: "14px" }}
                                                                />

                                                            </ListItem>
                                                            <Divider />
                                                        </React.Fragment>
                                                    )}
                                                </List>
                                            </Grid>
                                            <Grid item xs={0.5}></Grid>
                                        </Grid>
                                    </React.Fragment>
                                )}
                                グループ
                                <Divider />
                                <Grid container sx={{ mb:"10px"}}>
                                    <Grid item xs={0.5}></Grid>
                                    <Grid item xs>
                                        <List sx={{ width: '100%' }}>
                                            {shareGroupList.map((groupele) =>
                                                <React.Fragment key={`groupele${groupele.roomid}`}>
                                                    <ListItem
                                                        secondaryAction={
                                                            <Checkbox
                                                                edge="end"
                                                                onChange={() => handleShareListClick("group", groupele)}
                                                                checked={ groupele.isshared === "1" ? true : false }
                                                                />
                                                        }
                                                        alignItems="flex-start"
                                                    >
                                                            
                                                        <ListItemAvatar sx={{ mt: "auto", mb: "auto" }}>
                                                            <Avatar
                                                                src={`https://chat-tis.com/Static/downloadRoomAvatar?roomid=${groupele.roomid}&size=small`}
                                                                sx={{ width: 24, height: 24 }}
                                                            />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            disableTypography={true}
                                                            primary={groupele.roomname}
                                                            sx={{fontSize: "14px"}}
                                                        />
                                                            
                                                    </ListItem>
                                                    <Divider />
                                                </React.Fragment>
                                            )}
                                        </List>
                                    </Grid>
                                    <Grid item xs={0.5}></Grid>
                                </Grid>
                                コンタクト
                                <Divider />
                                <Grid container>
                                    <Grid item xs={0.5}></Grid>
                                    <Grid item xs>
                                        <List sx={{ width: '100%' }}>
                                            {shareContactList.map((contactele) =>
                                                <React.Fragment key={`contactele${contactele.roomid}`}>
                                                    <ListItem secondaryAction={
                                                            <Checkbox
                                                                edge="end"
                                                                onChange={() => handleShareListClick("contact", contactele)}
                                                                checked={contactele.isshared === "1" ? true : false}
                                                            />
                                                        }
                                                        alignItems="flex-start"
                                                    >
                                                        <ListItemAvatar sx={{ mt: "auto", mb: "auto" }}>
                                                            <Avatar
                                                                src={`https://chat-tis.com/Static/downloadAvatar?honbuid=${contactele.partnerHonbuidWhenContact}&size=small`}
                                                                sx={{ width: 24, height: 24 }}
                                                            />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            disableTypography={true}
                                                            primary={contactele.roomname}
                                                            sx={{ fontSize: "14px" }}
                                                        />
                                                    </ListItem>
                                                    <Divider />
                                                </React.Fragment>
                                            )}
                                        </List>
                                    </Grid>
                                    <Grid item xs={0.5}></Grid>
                                </Grid>
                            </DialogContent>
                        )}
                    <Divider />              
                </Dialog>

                {/*検索ダイアログ*/}
                <Dialog
                    open={searchDialog}
                    onClose={handleCloseSearchDialog}
                    fullScreen={isSpDevice ? true : false}
                    sx={isSpDevice ? {} : { marginLeft: "auto", marginRight: "auto", width: 400, marginTop: "auto", marginBottom: "auto", height: 550 }}
                    fullWidth
                    PaperProps={{ sx: { height: isSpDevice ? '100%' : 550 } }} // 高さを固定
                >
                    <DialogTitle sx={{ p: 0 }}>
                        <Grid container alignItems="center" sx={{ pl: 2, pr: 1, pt: 1, pb: 0 }}>
                            <Grid item xs />
                            <Grid item>
                                <Button
                                    onClick={handleCloseSearchDialog}
                                    sx={{ py: 0.5 }}
                                >
                                    閉じる
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabIndex} onChange={handleTabChange} variant="fullWidth">
                            <Tab label="ユーザーで検索" />
                            <Tab label="タイトルで検索" />
                        </Tabs>
                    </Box>
                    {tabIndex === 0 && (
                        <>
                            <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
                                {/* 1. 検索窓エリア */}
                                <Box sx={{ p: 2, pb: 1 }}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        value={memberSearchText}
                                        onChange={(e) => setMemberSearchText(e.target.value)}
                                        placeholder="ユーザー名で検索"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start"><SearchIcon /></InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>

                                {/* 2. 条件切り替えエリア */}
                                <Box sx={{
                                    px: 2,
                                    pb: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
                                        条件
                                    </Typography>

                                    <ToggleButtonGroup
                                        value={userSearchMode}
                                        exclusive
                                        onChange={(e, newMode) => {
                                            if (newMode !== null) {
                                                setUserSearchMode(newMode);
                                            }
                                        }}
                                        size="small"
                                        aria-label="search mode"
                                        sx={{
                                            gap: 1,
                                            '& .MuiToggleButtonGroup-grouped': {
                                                border: 1,
                                                borderColor: 'divider',
                                                borderRadius: 1, 
                                                '&:not(:first-of-type)': {
                                                    borderRadius: 1,
                                                    borderLeft: 1,
                                                    borderColor: 'divider',
                                                    marginLeft: 0, 
                                                },
                                                '&:first-of-type': {
                                                    borderRadius: 1,
                                                },
                                            }
                                        }}
                                    >
                                        <ToggleButton
                                            value="creator"
                                            sx={{
                                                px: 2,
                                                height: 28, 
                                                lineHeight: 1,
                                                fontSize: "12px" 
                                            }}
                                        >
                                            最終更新者
                                        </ToggleButton>
                                        <ToggleButton
                                            value="assignee"
                                            sx={{
                                                px: 2,
                                                height: 28, 
                                                lineHeight: 1,
                                                fontSize: "12px"
                                            }}
                                        >
                                            担当者
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </Box>

                                {/* 3. 区切り線 */}
                                <Divider />

                                {/* 4. ユーザーリストエリア */}
                                <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                                    <List dense>
                                        {(() => {
                                            const LShonbuid = sessionRef.current.honbuid;
                                            const sortedMembers = [...roomMembers].sort((a, b) => {
                                                if (String(a.honbuid) === LShonbuid) return -1;
                                                if (String(b.honbuid) === LShonbuid) return 1;
                                                return (a.name || "").localeCompare(b.name || "", 'ja');
                                            });
                                            const filteredMembers = sortedMembers.filter(member =>
                                                (member.name || "").toLowerCase().includes(memberSearchText.toLowerCase())
                                            );
                                            return filteredMembers.map((member) => (
                                                <ListItem key={member.honbuid} disablePadding>
                                                    <ListItemButton
                                                        onClick={() => handleToggleMember(String(member.honbuid))}
                                                        sx={{ pl: 2.5 }}
                                                    >
                                                        <ListItemIcon
                                                            sx={{ minWidth: 0, mr: 1 }}
                                                        >
                                                            <Checkbox
                                                                edge="start"
                                                                checked={selectedHonbuids.indexOf(String(member.honbuid)) !== -1}
                                                                tabIndex={-1}
                                                                disableRipple
                                                            />
                                                        </ListItemIcon>
                                                        <ListItemText primary={member.name} />
                                                    </ListItemButton>
                                                </ListItem>
                                            ));
                                        })()}
                                    </List>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClearAllSelection}>絞り込みをクリア</Button>
                            </DialogActions>
                        </>
                    )}

                    {tabIndex === 1 && (
                        <>
                            <DialogContent>
                                <TextField
                                    id="standard-search"
                                    label="予定のタイトル"
                                    type="search"
                                    variant="standard"
                                    fullWidth
                                    autoFocus={true}
                                    onKeyDown={e => handleSearchFormKeyDown(e)}
                                />
                                <Typography sx={{ mt: 1 }}>{searchedMessage}</Typography>
                                {searchedEvents.length > 0 && (
                                    <List sx={{ width: '100%', bgcolor: 'background.paper' }} subheader={<li />}>
                                        {searchedEvents.map((event, index) => (
                                            <li key={`search-eventid-${event.id}`}>
                                                <ul style={{ padding: 0 }}>
                                                    {searchSubHeaderFunc(event, index) &&
                                                        <ListSubheader sx={{ pl: 0, pb: 4, mb: 0, height: "10px" }}>{dayjs(event.start).format("YYYY/MM/DD")}</ListSubheader>
                                                    }
                                                    <ListItem disablePadding>
                                                        <ListItemButton onClick={() => handleEventClick(event)} dense sx={{ pl: 0 }}>
                                                            <Grid container>
                                                                <Grid item xs="auto">
                                                                    <div style={{ backgroundColor: event.backgroundColor, marginRight: 8, width: 4, height: '100%', display: 'inline-block' }}></div>
                                                                </Grid>
                                                                <Grid item xs>
                                                                    <ListItemText primary={event.title} secondary={FormatSearchedSecondary(event)} />
                                                                </Grid>
                                                            </Grid>
                                                        </ListItemButton>
                                                    </ListItem>
                                                </ul>
                                            </li>
                                        ))}
                                    </List>
                                )}
                            </DialogContent>
                        </>
                    )}
                </Dialog>

                <Dialog
                    open={batchOpen}
                    onClose={handleBatchClose}
                    fullScreen={isSpDevice ? true : false}
                    sx={isSpDevice ? {} : { marginLeft: "auto", marginRight: "auto", maxWidth: 600, marginTop: "auto", marginBottom: "auto", height: 750 }}
                    fullWidth
                >
                    <DialogTitle>
                        <Grid container sx={{ pl: 2, pr: 1, my: 1 }}>
                            <Grid item xs="auto" sx={{ mt: "auto", mb: "auto" }}>
                                <Typography variant="subtitle2" >
                                    予定の複製
                                </Typography>
                            </Grid>
                            <Grid item xs></Grid>
                            
                        </Grid>
                    </DialogTitle>
                    <Divider />
                    <DialogContent sx={{ pt: "10px", pb:"20px" }} >

                        <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="ja"
                            dateFormats={{ monthAndYear: "YYYY年M月" }} //カレンダー左上の日付表示
                            localeText={{
                                previousMonth: "前月を表示", // < のツールチップ
                                nextMonth: "次月を表示", // > のツールチップ
                            }}
                            sx={{
                                "& ::-webkit-scrollbar": {
                                    display: "none",
                                },
                                
                            }}
                        >
                            <Grid container>
                                
                                <Grid item xs={12}>
                                    <div style={{ textAlign: "center"}}>
                                        現在の予定開始日：  
                                        {dayjs(currentSelectionInfo.start).format("YYYY-MM-DD")}
                                    </div>
                                </Grid>

                                <Grid item xs={1}></Grid>
                                <Grid item xs={10} sx={{mt:1.5}}>
                                    <Button
                                        variant="contained"
                                        color="BGgrey200"
                                        onClick={handleSelectBatchCancel}
                                        fullWidth
                                    >
                                        複製せずに戻る
                                    </Button>
                                </Grid>
                                <Grid item xs={1}></Grid>


                                {/*繰り返しの登録後に予定が変わった場合は、繰り返し配列を破棄*/}
                                {/*通知の繰り返し登録がしこたまメンドイけどやったほうが良さげ*/}

                                <Grid item xs={12} sx={{ mt: 2 }} >
                                    <Card sx={{ backgroundColor: grey[200], py:2 }}>
                                    
                                        <Grid container>
                                            <Grid item xs={1}>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <ButtonGroup  color="BGgrey" variant="contained" aria-label="Basic button group" fullWidth sx={{ ma: 2 }}>
                                                    {/*選択時は"BGgrey"、非選択時は"BGwhitegrey"*/}
                                                    <Button color={selectedBatchPeriod === "d" ? "BGgrey" : "BGwhitegrey"} onClick={() => handleSelectBatchPeriod("d")}>日</Button>
                                                    <Button color={selectedBatchPeriod === "w" ? "BGgrey" : "BGwhitegrey"} onClick={() => handleSelectBatchPeriod("w")}>週</Button>
                                                    <Button color={selectedBatchPeriod === "m" ? "BGgrey" : "BGwhitegrey"} onClick={() => handleSelectBatchPeriod("m")}>月</Button>
                                                    <Button color={selectedBatchPeriod === "o" ? "BGgrey" : "BGwhitegrey"} onClick={() => handleSelectBatchPeriod("o")}>{isSpDevice?"他":"その他"}</Button>
                                                </ButtonGroup>
                                            </Grid>
                                            <Grid item xs={1}>
                                            </Grid>
                                        </Grid>


                                        <Grid container sx={{ mt: 1.5 }}>
                                            <Grid item xs={1}>
                                            </Grid>
                                            <Grid item xs={10}>
                                                {/*{batchOptions[selectedBatchPeriod]}*/}

                                                {
                                                    typeof batchOptions === 'object' &&
                                                    batchOptions !== null &&
                                                    Array.isArray(batchOptions[selectedBatchPeriod]) && // 配列であることを確認
                                                    batchOptions[selectedBatchPeriod].length > 0 && // 配列に要素が存在することを確認
                                                    (
                                                        <List
                                                            sx={{
                                                                width: '100%',
                                                                overflow: 'auto',
                                                                maxHeight: 200,
                                                            }}
                                                            dense
                                                        >
                                                            {(batchOptions[selectedBatchPeriod]).map((batchOption) => {
                                                                const labelId = `checkbox-list-label-${batchOption}`;
                                                                return (
                                                                    <ListItem
                                                                        alignItems="flex-start"
                                                                        key={`batchOption-${batchOption}`}
                                                                        disablePadding
                                                                        dense
                                                                    >
                                                                        <ListItemButton role={undefined} onClick={handleSelectBatchOption(batchOption)} dense>
                                                                            <ListItemIcon sx={{mr:-2,my:-2}}>
                                                                                <Checkbox
                                                                                    edge="start"
                                                                                    color="grey"
                                                                                    checked={batchChecked.includes(batchOption)}
                                                                                    tabIndex={-1}
                                                                                    disableRipple
                                                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }}
                                                                                />
                                                                            </ListItemIcon>
                                                                            <ListItemText
                                                                                id={labelId}
                                                                                primary={batchOption}
                                                                                sx={{ fontSize: "14px" }}
                                                                            />
                                                                        </ListItemButton>
                                                                    </ListItem>
                                                                );
                                                            }
                                                            )}
                                                        </List>
                                                    )
                                                }
                                                <Divider />
                                                {/*いつまで*/}
                                                <Box sx={{ mt:1.5}}>
                                                    <Box sx={{fontSize:"14px" }}>
                                                        ・いつまで
                                                    </Box>
                                                    <Box sx={{ ml:2, fontSize: "10.5px" }}>
                                                        <Grid container>
                                                            <Grid item>
                                                            ※
                                                            </Grid>
                                                            <Grid item xs>
                                                                一度に複製できる数は最大30件です。<br />
                                                                上限到達以降の予定は複製されません。
                                                            </Grid>
                                                        </Grid>
                                                        <Box sx={{ mt: 0.5 }}>
                                                            <ButtonDatePicker
                                                                label={`${!batchLimitDate || batchLimitDate ==="Invalid Date"
                                                                    ? "期間を選択"
                                                                    : dayjs(batchLimitDate).format(
                                                                        "YYYY/MM/DD"
                                                                    )
                                                                    }`}
                                                                value={dayjs(batchLimitDate)}
                                                                onChange={(event) =>
                                                                    updateBatchLimitDate(event)
                                                                }
                                                                // endのみminDate指定
                                                                minDate={dayjs(currentSelectionInfo.start)}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={1}>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>

                                <Grid item xs={1}></Grid>
                                <Grid item xs={10} sx={{ mt: "20px" }}>
                                    <Button
                                        variant="contained"
                                        disabled={!batchChecked[0] || !batchLimitDate || batchLimitDate === "Invalid Date" }
                                        onClick={handleBatchClose}
                                        fullWidth
                                    >
                                        設定して戻る {batchChecked[0] && batchLimitDate && batchLimitDate !== "Invalid Date" ? `（${selectedBatchDates.length}件）`:""}
                                    </Button>
                                </Grid>
                                <Grid item xs={1}></Grid>
                            </Grid>
                        </LocalizationProvider>
                    </DialogContent>
                    <Divider />                    
                </Dialog>
                <Dialog
                    open={assigneeDialogOpen}
                    onClose={handleCloseAssigneeDialog}
                    fullScreen={isSpDevice} 
                    fullWidth
                    maxWidth="xs" 
                    PaperProps={{
                        sx: {
                            height: isSpDevice ? '100%' : '80vh',
                            maxHeight: isSpDevice ? 'none' : 600
                        }
                    }}
                >
                    <DialogTitle sx={{ p: 2, fontSize: "16px", fontWeight: "bold" }}>
                        担当者を選択
                    </DialogTitle>
                    <Divider />

                    <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                        {/* 検索バーエリア */}
                        <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                placeholder="ユーザー名で検索"
                                value={assigneeSearchText}
                                onChange={(e) => setAssigneeSearchText(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start"><SearchIcon /></InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        {/* リストエリア */}
                        <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                            <List dense>
                                {(() => {
                                    const LShonbuid = sessionRef.current.honbuid;

                                    // 1. ソート（自分を先頭に、あとは名前順）
                                    const sortedMembers = [...roomMembers].sort((a, b) => {
                                        if (String(a.honbuid) === LShonbuid) return -1;
                                        if (String(b.honbuid) === LShonbuid) return 1;
                                        return (a.name || "").localeCompare(b.name || "", 'ja');
                                    });

                                    // 2. フィルタリング（検索テキストで絞り込み）
                                    const filteredMembers = sortedMembers.filter(member =>
                                        (member.name || "").toLowerCase().includes(assigneeSearchText.toLowerCase())
                                    );

                                    return filteredMembers.map((member) => {
                                        const isSelected = currentAssignees.some(a => a.honbuid === member.honbuid);

                                        return (
                                            <ListItem key={member.honbuid} disablePadding>
                                                <ListItemButton
                                                    onClick={() => {
                                                        if (isSelected) {
                                                            setCurrentAssignees(prev => prev.filter(a => a.honbuid !== member.honbuid));
                                                        } else {
                                                            setCurrentAssignees(prev => [...prev, { honbuid: member.honbuid, name: member.name }]);
                                                        }
                                                    }}
                                                    sx={{ pl: 2.5 }}
                                                >
                                                    <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                                        <Checkbox
                                                            edge="start"
                                                            checked={isSelected}
                                                            tabIndex={-1}
                                                            disableRipple
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText primary={member.name} />
                                                </ListItemButton>
                                            </ListItem>
                                        );
                                    });
                                })()}
                            </List>
                        </Box>
                    </DialogContent>

                    <Divider />
                    <DialogActions>
                        <Button onClick={handleCloseAssigneeDialog}>閉じる</Button>
                        <Button variant="contained" onClick={handleCloseAssigneeDialog}>確定</Button>
                    </DialogActions>
                </Dialog>

                {/* ヘルプパネル */}
                <Drawer
                    anchor="right"
                    open={helpOpen}
                    onClose={() => setHelpOpen(false)}
                    PaperProps={{ sx: { width: isSpDevice ? "100vw" : 420 } }}
                >
                    <Box sx={{
                        background: `linear-gradient(to right, #039BE5, ${alpha("#039BE5", 0.7)})`,
                        color: "#fff",
                        borderBottom: `3px solid ${isDarkMode ? "#000" : "#fff"}`,
                        px: 2,
                        py: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}>
                        <Typography variant="h6" fontWeight="bold">ヘルプ</Typography>
                        <IconButton size="small" sx={{ color: "#fff" }} onClick={() => setHelpOpen(false)}>
                            <ClearIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ p: 3 }}>
                        <Typography variant="body1">カレンダーのヘルプ機能は現在準備中です</Typography>
                    </Box>
                </Drawer>

                {/*素敵なトースト https://react-hot-toast.com/ */}
                <Toaster
                    position="bottom-left"
                    reverseOrder={true}
                />
            </div>
            </ThemeProvider>
    );
}


// ボタンカレンダー用パーツ
function ButtonField(props) {
    const {
        setOpen,
        label,
        id,
        disabled,
        InputProps: { ref } = {},
        inputProps: { "aria-label": ariaLabel } = {},
    } = props;

    return (
        <Button
            variant="outlined"
            id={id}
            disabled={disabled}
            // color={btnColor ? btnColor : ""}
            ref={ref}
            aria-label={ariaLabel}
            onClick={() => setOpen?.((prev) => !prev)}
            sx={{ py: 0.25 }}
        >
            {label ?? "日時を選択"}
        </Button>
    );
}

// ボタンカレンダー用パーツ(date)
function ButtonDatePicker(props) {
    const [open, setOpen] = React.useState(false);
    return (
        <DatePicker
            slots={{ field: ButtonField, ...props.slots }}
            slotProps={{ field: { setOpen }, toolbar: { toolbarFormat: 'M月D日' } }}
            {...props}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
        />
    );
}

// ボタンカレンダー用パーツ(datetime)
function ButtonDateTimePicker(props) {
    const { label, value, onChange, minDateTime, minDate } = props;
    const [open, setOpen] = React.useState(false);
    const [tempValue, setTempValue] = React.useState(dayjs(value));
    const [showDial, setShowDial] = React.useState(false);

    const timeInputRef = React.useRef(null);
    const theme = useTheme();
    const isSpDevice = useMediaQuery(theme.breakpoints.down('sm'));

    React.useEffect(() => {
        if (open) setTempValue(dayjs(value));
    }, [open, value]);

    const handleDateChange = (newValue) => {
        setTempValue(newValue.hour(tempValue.hour()).minute(tempValue.minute()));
        if (timeInputRef.current) {
            setTimeout(() => {
                timeInputRef.current.focus();
            }, 100);
        }
    };

    // PC版ダイヤル用の時間変更ハンドラー
    const handleTimeChange = (newValue) => {
        if (!newValue) return;
        setTempValue(tempValue.hour(newValue.hour()).minute(newValue.minute()));
    };

    // スマホ版・PC版共通のネイティブ時間入力用のハンドラー
    const handleNativeTimeChange = (e) => {
        const timeStr = e.target.value;
        if (!timeStr) return;
        const [h, m] = timeStr.split(':');
        setTempValue(tempValue.hour(parseInt(h, 10)).minute(parseInt(m, 10)));
    };

    const [pcTimeInput, setPcTimeInput] = React.useState(tempValue.format('HH:mm'));
    React.useEffect(() => {
        setPcTimeInput(tempValue.format('HH:mm'));
    }, [tempValue]);

    // PC向け：テキスト入力時の処理
    const handlePcTimeChange = (e) => {
        setPcTimeInput(e.target.value);
    };

    // PC向け：入力欄からカーソルが外れた時に、一気にパースして変換する
    const handlePcTimeBlur = () => {
        const val = pcTimeInput;
        const halfVal = val.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
        const raw = halfVal.replace(':', '');
        if (/^\d{3,4}$/.test(raw)) {
            let h = parseInt(raw.length === 3 ? raw.slice(0, 1) : raw.slice(0, 2), 10);
            let m = parseInt(raw.length === 3 ? raw.slice(1, 3) : raw.slice(2, 4), 10);
            if (h >= 0 && h <= 23 && m >= 0 && m <= 59) {
                setTempValue(tempValue.hour(h).minute(m));
                return;
            }
        }
        setPcTimeInput(tempValue.format('HH:mm'));
    };

    const handleAccept = () => {
        onChange(tempValue);
        setOpen(false);
        setShowDial(false); 
    };

    return (
        <>
            <Button variant="outlined" onClick={() => setOpen(true)} sx={{ py: 0.25 }}>
                {label ?? "日時を選択"}
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="md"
            >
                <DialogTitle sx={{ p: 0, display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton onClick={() => setOpen(false)} sx={{ m: 0.5 }}>
                        <ClearIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{
                    p: 1,
                    pt: 0,
                    overflowX: 'hidden',
                    display: 'flex',
                    flexDirection: isSpDevice ? 'column' : 'row',
                    alignItems: isSpDevice ? 'center' : 'flex-start'
                }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
                        {/* カレンダー部分 */}
                        <DateCalendar
                            value={tempValue}
                            onChange={handleDateChange}
                            minDate={minDateTime || minDate ? dayjs(minDateTime || minDate) : undefined}
                            sx={{ mt: -1 }}
                        />
                        {isSpDevice ? (
                            <>
                                <Divider sx={{ my: 1, width: '100%' }} />
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', my: 1.5 }}>
                                    <Typography sx={{ mr: 2 }}>時間:</Typography>
                                    <TextField
                                        inputRef={timeInputRef}
                                        type="text" 
                                        inputMode="numeric"
                                        size="small"
                                        value={pcTimeInput}
                                        onChange={handlePcTimeChange}
                                        onBlur={handlePcTimeBlur}
                                        onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                                        placeholder="1500"
                                        inputProps={{ maxLength: 5 }}
                                        sx={{ width: 140 }}
                                    />
                                </Box>
                            </>
                        ) : (
                            <>
                                <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
                                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', pt: 1 }}>
                                    <Typography variant="subtitle2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                                        時間を選択
                                    </Typography>

                                    {/* PC版：直接入力欄と時計アイコンの組み合わせ */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
                                            <TextField
                                                inputRef={timeInputRef}
                                                type="text"
                                                size="small"
                                                value={pcTimeInput}
                                                onChange={handlePcTimeChange}
                                                onBlur={handlePcTimeBlur}
                                                onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                                                placeholder="1500"
                                                inputProps={{ maxLength: 5 }}
                                                sx={{ width: 140 }}
                                            />
                                            <IconButton
                                                onClick={() => setShowDial(!showDial)}
                                                sx={{ ml: 1 }}
                                                color={showDial ? "primary" : "default"}
                                            >
                                                <AccessTimeIcon />
                                            </IconButton>
                                        </Box>

                                    {/* 時計アイコンが押されたらダイヤルを展開 */}
                                    {showDial && (
                                        <MultiSectionDigitalClock
                                            value={tempValue}
                                            onChange={handleTimeChange}
                                            timeSteps={{ minutes: 1 }}
                                        />
                                    )}
                                </Box>
                            </>
                        )}
                    </LocalizationProvider>
                </DialogContent>

                <DialogActions sx={{ pt: 0, px: 3, pb: 2 }}>
                    <Button onClick={handleAccept} variant="contained" disableElevation fullWidth={isSpDevice}>
                        確定
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

// 通知設定ボタン用パーツ
function notificationButtonField(props) {
    const {
        setOpen,
        label,
        id,
        disabled,
        InputProps: { ref } = {},
        inputProps: { "aria-label": ariaLabel } = {},
    } = props;

    return (
        <Button
            // variant="outlined"

            id={id}
            disabled={disabled}
            color="inherit"
            size="small"
            ref={ref}
            aria-label={ariaLabel}
            onClick={() => setOpen?.((prev) => !prev)}
        >
            {label ?? "通知日時を選択"}
        </Button>
    );
}

// 通知用ボタンカレンダーパーツ(datetime)
function NotificationDateTimePicker(props) {
    const { label, value, onAccept } = props;
    const [open, setOpen] = React.useState(false);
    const [tempValue, setTempValue] = React.useState(dayjs(value));

    React.useEffect(() => {
        if (open) setTempValue(dayjs(value));
    }, [open, value]);

    const handleDateChange = (newValue) => {
        setTempValue(newValue.hour(tempValue.hour()).minute(tempValue.minute()));
    };

    const handleTimeChange = (e) => {
        const timeStr = e.target.value;
        if (!timeStr) return;
        const [h, m] = timeStr.split(':');
        setTempValue(tempValue.hour(parseInt(h, 10)).minute(parseInt(m, 10)));
    };

    return (
        <>
            <Button color="inherit" size="small" onClick={() => setOpen(true)}>
                {label ?? "通知日時を選択"}
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle sx={{ pb: 1, fontSize: '1rem' }}>通知日時を設定</DialogTitle>
                <DialogContent sx={{ p: 1, overflowX: 'hidden' }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
                        <DateCalendar
                            value={tempValue}
                            onChange={handleDateChange}
                            disablePast={true}
                        />
                    </LocalizationProvider>
                    <Divider sx={{ my: 1 }} />
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 1 }}>
                        <Typography>時間:</Typography>
                        <TextField
                            type="time"
                            size="small"
                            value={tempValue.format('HH:mm')}
                            onChange={handleTimeChange}
                            sx={{ width: 140 }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>キャンセル</Button>
                    <Button onClick={() => { onAccept(tempValue); setOpen(false); }} variant="contained" disableElevation>
                        確定
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


// 繰り返し登録用パーツ ボタン
function ButtonBatchField(props) {
    const {
        setOpen,
        label,
        id,
        disabled,
        InputProps: { ref } = {},
        inputProps: { "aria-label": ariaLabel } = {},
    } = props;

    return (
        <Button
            variant="plain"
            id={id}
            disabled={disabled}
            // color={btnColor ? btnColor : ""}
            ref={ref}
            aria-label={ariaLabel}
            onClick={() => setOpen?.((prev) => !prev)}
            sx={{ py: 0.25 }}
        >
            {label}
        </Button>
    );
}


// 繰り返し登録用パーツ datepicker
function ButtonBatchDatePicker(props) {
    const [open, setOpen] = React.useState(false);
    return (
        <DatePicker
            slots={{ field: ButtonBatchField, ...props.slots }}
            slotProps={{ field: { setOpen }, toolbar: { toolbarFormat: 'M月D日' } }}
            {...props}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
        />
    );
}





export default App;
